export const LAYOUT_SETTINGS = {
  SHORT_MENU: 19,
  TOPBAR_BACKGROUND: 20,
  TOPBAR_TEXT_COLOR: 21,
  SIDEBAR_BACKGROUND: 22,
  SIDEBAR_TEXT_COLOR: 23,
  SIDEBAR_ICON_COLOR: 30,
  SIDEBAR_HOVER_COLOR: 31,
  ACCENT_COLOR: 26,
  ACCENT_TEXT_COLOR: 32,
}

export const ActivityType = {
  CALL: '1',
  APOINTMENT: '2',
  TASK: '3',
  DEADLINE: '4',
  EMAIL: '5',
  FOLLOWUP: '6',
  OTHERS: '7'

}
export const TASK_ICON = {
  call: 'phone',
  meeting: 'event_note',
  task: 'assignment_turned_in',
  deadline: 'query_builder',
  email: 'mail_outline',
  followup: 'person_add',
  others: 'more_horiz',
}
export const SITE_NOTIFICATION = {
  SMS: 0,
  EMAIL: 1,
  CALL: 2,
  CAMPAIGN_PAUSE: 5
}
export const CODE_SNIPPET = {
  AFTER_LOGIN: 1,
  REGISTRATION: 2,
  POSITION_HEADER: 1,
  POSITION_FOOTER: 2,
}

export const MESSAGE_TYPE = {
  SMS: 1,
  MMS: 2,
  VOICE: 3,
  EMAIL: 4,
  CALL: 5,
  VIDEO_EMAIL: 14,
  FORM_RESPONSE: 26,
}

export const NOTIFICATION_MESSAGE_TYPE = {
  SMS: 0,
  EMAIL: 1,
  CALL: 2,
  FORM_RESPONSE: 4,
}

export const NOTIFICATION_OUTCOME_TYPE = {
  ANSWERED: 1,
  MISSED_CALL: 2,
  VOICEMAIL: 3
}

export const AUTO_DIALER = {
  STATUS: {
    NOT_STARTED: 0,
    RUNNING: 1,
    PAUSED: 2,
    COMPLETED: 3
  },
  ACTION_IF_NOT_ANSWER: {
    DO_NOTHING: 0,
    DROP_VOICEMAIL: 1,
    SEND_SMS: 2,
    BOTH: 3
  }
}

export const CALL_TYPE = {
  INCOMING: 1,
  GLOBAL_DIALER: 2,
  AUTO_DIALER: 3,
}

export const LEAD_TYPES = [
  {
    value: "CLIENT",
    label: "Client"
  },
  {
    value: 'VENDOR',
    label: "Vendor"
  },
  {
    value: 'LEAD',
    label: "Lead"
  }
];
export const PHONE_STATE = {
  mobile: "mobile",
  landline: "landline",
  voip: "voip",
  unknown: "unknown"
};
export const PHONE_TYPES = [
  {
    value: PHONE_STATE.mobile,
    label: "Mobile"
  },
  {
    value: PHONE_STATE.landline,
    label: "Landline"
  },
  {
    value: PHONE_STATE.voip,
    label: "Voip"
  },
  {
    value: PHONE_STATE.unknown,
    label: "Unknown"
  }
];

export const leadPermission = {
  REQUEST_TYPE_ADD_COLLABORATOR: 1,
  REQUEST_TYPE_CHANGE_OWNER: 2
}

export const US_STATE_LIST = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];


export const emailProvider = {
  DEFAULT: 0,
  NYLAS_V1: 1,
  NYLAS_V3: 2
}

export const NYLAS_V3_AGENCIES = [1, 125, 53, 82, 57, 106, 97, 16, 30, 62, 40, 87, 92, 103, 129, 38, 67, 85, 159, 193, 157, 45, 59, 190, 102, 145, 51, 201, 225, 73, 173, 42, 32, 150, 124, 44, 234, 226, 215, 214, 213, 46, 141, 218, 216, 219, 235];

export const ADD_DEAL_TYPE = {
  NEW: 1,
  EXISTING: 2
};

export const APPOINTMENT_SCHEDULE_PAST = 'PAST';
export const APPOINTMENT_SCHEDULE_TODAY = 'TODAY';
export const APPOINTMENT_SCHEDULE_UPCOMING = 'UPCOMING';
export const FREE_MAP_ACCESS_AGENCIES = [1, 236];

export const STRIPE_PAYMENT_USER_TYPE = {
  NEW_USER: 'NEW_USER',
  OLD_USER: 'OLD_USER'
};

export const BUSINESS_TYPE_OPTIONS = [
  { "value": "ASSOCIATION", "title": "Association" },
  { "value": "CORPORATION", "title": "Corporation" },
  { "value": "INDIVIDUAL", "title": "Individual" },
  { "value": "NON_PROFIT", "title": "Non-Profit" },
  { "value": "LIMITED_LIABILITY_COMPANY", "title": "Limited Liability Company" },
  { "value": "PARTNERSHIP", "title": "Partnership" },
  { "value": "TRUST", "title": "Trust" }
];

export const CustomFieldType = {
    TEXT : 1,
    MULTILINE_TEXT : 2,
    NUMERIC : 3,
    DATE : 4,
    CHECKBOX : 5,
    SELECT : 6,
    RADIO : 7,
    PHONE : 8,
    ZIP_CODE : 9,
    WEBSITE : 10,
    DATETIME: 11
}


export const BUSINESS_CLASSIFICATION_OPTIONS = 
[
  {
    "id": 111110,
    "title": "Soybean Farming",
    "display_name": "(111110) Soybean Farming"
  },
  {
    "id": 111120,
    "title": "Oilseed (except Soybean) Farming",
    "display_name": "(111120) Oilseed (except Soybean) Farming"
  },
  {
    "id": 111130,
    "title": "Dry Pea and Bean Farming",
    "display_name": "(111130) Dry Pea and Bean Farming"
  },
  {
    "id": 111140,
    "title": "Wheat Farming",
    "display_name": "(111140) Wheat Farming"
  },
  {
    "id": 111150,
    "title": "Corn Farming",
    "display_name": "(111150) Corn Farming"
  },
  {
    "id": 111160,
    "title": "Rice Farming",
    "display_name": "(111160) Rice Farming"
  },
  {
    "id": 111191,
    "title": "Oilseed and Grain Combination Farming",
    "display_name": "(111191) Oilseed and Grain Combination Farming"
  },
  {
    "id": 111199,
    "title": "All Other Grain Farming",
    "display_name": "(111199) All Other Grain Farming"
  },
  {
    "id": 111211,
    "title": "Potato Farming",
    "display_name": "(111211) Potato Farming"
  },
  {
    "id": 111219,
    "title": "Other Vegetable (except Potato) and Melon Farming",
    "display_name": "(111219) Other Vegetable (except Potato) and Melon Farming"
  },
  {
    "id": 111310,
    "title": "Orange Groves",
    "display_name": "(111310) Orange Groves"
  },
  {
    "id": 111320,
    "title": "Citrus (except Orange) Groves",
    "display_name": "(111320) Citrus (except Orange) Groves"
  },
  {
    "id": 111331,
    "title": "Apple Orchards",
    "display_name": "(111331) Apple Orchards"
  },
  {
    "id": 111332,
    "title": "Grape Vineyards",
    "display_name": "(111332) Grape Vineyards"
  },
  {
    "id": 111333,
    "title": "Strawberry Farming",
    "display_name": "(111333) Strawberry Farming"
  },
  {
    "id": 111334,
    "title": "Berry (except Strawberry) Farming",
    "display_name": "(111334) Berry (except Strawberry) Farming"
  },
  {
    "id": 111335,
    "title": "Tree Nut Farming",
    "display_name": "(111335) Tree Nut Farming"
  },
  {
    "id": 111336,
    "title": "Fruit and Tree Nut Combination Farming",
    "display_name": "(111336) Fruit and Tree Nut Combination Farming"
  },
  {
    "id": 111339,
    "title": "Other Noncitrus Fruit Farming",
    "display_name": "(111339) Other Noncitrus Fruit Farming"
  },
  {
    "id": 111411,
    "title": "Mushroom Production",
    "display_name": "(111411) Mushroom Production"
  },
  {
    "id": 111419,
    "title": "Other Food Crops Grown Under Cover",
    "display_name": "(111419) Other Food Crops Grown Under Cover"
  },
  {
    "id": 111421,
    "title": "Nursery and Tree Production",
    "display_name": "(111421) Nursery and Tree Production"
  },
  {
    "id": 111422,
    "title": "Floriculture Production",
    "display_name": "(111422) Floriculture Production"
  },
  {
    "id": 111910,
    "title": "Tobacco Farming",
    "display_name": "(111910) Tobacco Farming"
  },
  {
    "id": 111920,
    "title": "Cotton Farming",
    "display_name": "(111920) Cotton Farming"
  },
  {
    "id": 111930,
    "title": "Sugarcane Farming",
    "display_name": "(111930) Sugarcane Farming"
  },
  {
    "id": 111940,
    "title": "Hay Farming",
    "display_name": "(111940) Hay Farming"
  },
  {
    "id": 111991,
    "title": "Sugar Beet Farming",
    "display_name": "(111991) Sugar Beet Farming"
  },
  {
    "id": 111992,
    "title": "Peanut Farming",
    "display_name": "(111992) Peanut Farming"
  },
  {
    "id": 111998,
    "title": "All Other Miscellaneous Crop Farming",
    "display_name": "(111998) All Other Miscellaneous Crop Farming"
  },
  {
    "id": 112111,
    "title": "Beef Cattle Ranching and Farming",
    "display_name": "(112111) Beef Cattle Ranching and Farming"
  },
  {
    "id": 112112,
    "title": "Cattle Feedlots",
    "display_name": "(112112) Cattle Feedlots"
  },
  {
    "id": 112120,
    "title": "Dairy Cattle and Milk Production",
    "display_name": "(112120) Dairy Cattle and Milk Production"
  },
  {
    "id": 112130,
    "title": "Dual-Purpose Cattle Ranching and Farming",
    "display_name": "(112130) Dual-Purpose Cattle Ranching and Farming"
  },
  {
    "id": 112210,
    "title": "Hog and Pig Farming",
    "display_name": "(112210) Hog and Pig Farming"
  },
  {
    "id": 112310,
    "title": "Chicken Egg Production",
    "display_name": "(112310) Chicken Egg Production"
  },
  {
    "id": 112320,
    "title": "Broilers and Other Meat Type Chicken Production",
    "display_name": "(112320) Broilers and Other Meat Type Chicken Production"
  },
  {
    "id": 112330,
    "title": "Turkey Production",
    "display_name": "(112330) Turkey Production"
  },
  {
    "id": 112340,
    "title": "Poultry Hatcheries",
    "display_name": "(112340) Poultry Hatcheries"
  },
  {
    "id": 112390,
    "title": "Other Poultry Production",
    "display_name": "(112390) Other Poultry Production"
  },
  {
    "id": 112410,
    "title": "Sheep Farming",
    "display_name": "(112410) Sheep Farming"
  },
  {
    "id": 112420,
    "title": "Goat Farming",
    "display_name": "(112420) Goat Farming"
  },
  {
    "id": 112511,
    "title": "Finfish Farming and Fish Hatcheries",
    "display_name": "(112511) Finfish Farming and Fish Hatcheries"
  },
  {
    "id": 112512,
    "title": "Shellfish Farming",
    "display_name": "(112512) Shellfish Farming"
  },
  {
    "id": 112519,
    "title": "Other Aquaculture",
    "display_name": "(112519) Other Aquaculture"
  },
  {
    "id": 112910,
    "title": "Apiculture",
    "display_name": "(112910) Apiculture"
  },
  {
    "id": 112920,
    "title": "Horses and Other Equine Production",
    "display_name": "(112920) Horses and Other Equine Production"
  },
  {
    "id": 112930,
    "title": "Fur-Bearing Animal and Rabbit Production",
    "display_name": "(112930) Fur-Bearing Animal and Rabbit Production"
  },
  {
    "id": 112990,
    "title": "All Other Animal Production",
    "display_name": "(112990) All Other Animal Production"
  },
  {
    "id": 113110,
    "title": "Timber Tract Operations",
    "display_name": "(113110) Timber Tract Operations"
  },
  {
    "id": 113210,
    "title": "Forest Nurseries and Gathering of Forest Products",
    "display_name": "(113210) Forest Nurseries and Gathering of Forest Products"
  },
  {
    "id": 113310,
    "title": "Logging",
    "display_name": "(113310) Logging"
  },
  {
    "id": 114111,
    "title": "Finfish Fishing",
    "display_name": "(114111) Finfish Fishing"
  },
  {
    "id": 114112,
    "title": "Shellfish Fishing",
    "display_name": "(114112) Shellfish Fishing"
  },
  {
    "id": 114119,
    "title": "Other Marine Fishing",
    "display_name": "(114119) Other Marine Fishing"
  },
  {
    "id": 114210,
    "title": "Hunting and Trapping",
    "display_name": "(114210) Hunting and Trapping"
  },
  {
    "id": 115111,
    "title": "Cotton Ginning",
    "display_name": "(115111) Cotton Ginning"
  },
  {
    "id": 115112,
    "title": "Soil Preparation, Planting, and Cultivating",
    "display_name": "(115112) Soil Preparation, Planting, and Cultivating"
  },
  {
    "id": 115113,
    "title": "Crop Harvesting, Primarily by Machine",
    "display_name": "(115113) Crop Harvesting, Primarily by Machine"
  },
  {
    "id": 115114,
    "title": "Postharvest Crop Activities (except Cotton Ginning)",
    "display_name": "(115114) Postharvest Crop Activities (except Cotton Ginning)"
  },
  {
    "id": 115115,
    "title": "Farm Labor Contractors and Crew Leaders",
    "display_name": "(115115) Farm Labor Contractors and Crew Leaders"
  },
  {
    "id": 115116,
    "title": "Farm Management Services",
    "display_name": "(115116) Farm Management Services"
  },
  {
    "id": 115210,
    "title": "Support Activities for Animal Production",
    "display_name": "(115210) Support Activities for Animal Production"
  },
  {
    "id": 115310,
    "title": "Support Activities for Forestry",
    "display_name": "(115310) Support Activities for Forestry"
  },
  {
    "id": 211120,
    "title": "Crude Petroleum Extraction",
    "display_name": "(211120) Crude Petroleum Extraction"
  },
  {
    "id": 211130,
    "title": "Natural Gas Extraction",
    "display_name": "(211130) Natural Gas Extraction"
  },
  {
    "id": 212114,
    "title": "Surface Coal Mining",
    "display_name": "(212114) Surface Coal Mining"
  },
  {
    "id": 212115,
    "title": "Underground Coal Mining",
    "display_name": "(212115) Underground Coal Mining"
  },
  {
    "id": 212210,
    "title": "Iron Ore Mining",
    "display_name": "(212210) Iron Ore Mining"
  },
  {
    "id": 212220,
    "title": "Gold Ore and Silver Ore Mining",
    "display_name": "(212220) Gold Ore and Silver Ore Mining"
  },
  {
    "id": 212230,
    "title": "Copper, Nickel, Lead, and Zinc Mining",
    "display_name": "(212230) Copper, Nickel, Lead, and Zinc Mining"
  },


   {
    "id": 212290,
    "title": "Other Metal Ore Mining",
    "display_name": "(212290) Other Metal Ore Mining"
  },
  {
    "id": 212311,
    "title": "Dimension Stone Mining and Quarrying",
    "display_name": "(212311) Dimension Stone Mining and Quarrying"
  },
  {
    "id": 212312,
    "title": "Crushed and Broken Limestone Mining and Quarrying",
    "display_name": "(212312) Crushed and Broken Limestone Mining and Quarrying"
  },
  {
    "id": 212313,
    "title": "Crushed and Broken Granite Mining and Quarrying",
    "display_name": "(212313) Crushed and Broken Granite Mining and Quarrying"
  },
  {
    "id": 212319,
    "title": "Other Crushed and Broken Stone Mining and Quarrying",
    "display_name": "(212319) Other Crushed and Broken Stone Mining and Quarrying"
  },
  {
    "id": 212321,
    "title": "Construction Sand and Gravel Mining",
    "display_name": "(212321) Construction Sand and Gravel Mining"
  },
  {
    "id": 212322,
    "title": "Industrial Sand Mining",
    "display_name": "(212322) Industrial Sand Mining"
  },
  {
    "id": 212323,
    "title": "Kaolin, Clay, and Ceramic and Refractory Minerals Mining",
    "display_name": "(212323) Kaolin, Clay, and Ceramic and Refractory Minerals Mining"
  },
  {
    "id": 212390,
    "title": "Other Nonmetallic Mineral Mining and Quarrying",
    "display_name": "(212390) Other Nonmetallic Mineral Mining and Quarrying"
  },
  {
    "id": 213111,
    "title": "Drilling Oil and Gas Wells",
    "display_name": "(213111) Drilling Oil and Gas Wells"
  },
  {
    "id": 213112,
    "title": "Support Activities for Oil and Gas Operations",
    "display_name": "(213112) Support Activities for Oil and Gas Operations"
  },
  {
    "id": 213113,
    "title": "Support Activities for Coal Mining",
    "display_name": "(213113) Support Activities for Coal Mining"
  },
  {
    "id": 213114,
    "title": "Support Activities for Metal Mining",
    "display_name": "(213114) Support Activities for Metal Mining"
  },
  {
    "id": 213115,
    "title": "Support Activities for Nonmetallic Minerals (except Fuels) Mining",
    "display_name": "(213115) Support Activities for Nonmetallic Minerals (except Fuels) Mining"
  },
  {
    "id": 221111,
    "title": "Hydroelectric Power Generation",
    "display_name": "(221111) Hydroelectric Power Generation"
  },
  {
    "id": 221112,
    "title": "Fossil Fuel Electric Power Generation",
    "display_name": "(221112) Fossil Fuel Electric Power Generation"
  },
  {
    "id": 221113,
    "title": "Nuclear Electric Power Generation",
    "display_name": "(221113) Nuclear Electric Power Generation"
  },
  {
    "id": 221114,
    "title": "Solar Electric Power Generation",
    "display_name": "(221114) Solar Electric Power Generation"
  },
  {
    "id": 221115,
    "title": "Wind Electric Power Generation",
    "display_name": "(221115) Wind Electric Power Generation"
  },
  {
    "id": 221116,
    "title": "Geothermal Electric Power Generation",
    "display_name": "(221116) Geothermal Electric Power Generation"
  },
  {
    "id": 221117,
    "title": "Biomass Electric Power Generation",
    "display_name": "(221117) Biomass Electric Power Generation"
  },
  {
    "id": 221118,
    "title": "Other Electric Power Generation",
    "display_name": "(221118) Other Electric Power Generation"
  },
  {
    "id": 221121,
    "title": "Electric Bulk Power Transmission and Control",
    "display_name": "(221121) Electric Bulk Power Transmission and Control"
  },
  {
    "id": 221122,
    "title": "Electric Power Distribution",
    "display_name": "(221122) Electric Power Distribution"
  },
  {
    "id": 221210,
    "title": "Natural Gas Distribution",
    "display_name": "(221210) Natural Gas Distribution"
  },
  {
    "id": 221310,
    "title": "Water Supply and Irrigation Systems",
    "display_name": "(221310) Water Supply and Irrigation Systems"
  },
  {
    "id": 221320,
    "title": "Sewage Treatment Facilities",
    "display_name": "(221320) Sewage Treatment Facilities"
  },
  {
    "id": 221330,
    "title": "Steam and Air-Conditioning Supply",
    "display_name": "(221330) Steam and Air-Conditioning Supply"
  },
  {
    "id": 236115,
    "title": "New Single-Family Housing Construction (except For-Sale Builders)",
    "display_name": "(236115) New Single-Family Housing Construction (except For-Sale Builders)"
  },
  {
    "id": 236116,
    "title": "New Multifamily Housing Construction (except For-Sale Builders)",
    "display_name": "(236116) New Multifamily Housing Construction (except For-Sale Builders)"
  },
  {
    "id": 236117,
    "title": "New Housing For-Sale Builders",
    "display_name": "(236117) New Housing For-Sale Builders"
  },
  {
    "id": 236118,
    "title": "Residential Remodelers",
    "display_name": "(236118) Residential Remodelers"
  },
  {
    "id": 236210,
    "title": "Industrial Building Construction",
    "display_name": "(236210) Industrial Building Construction"
  },
  {
    "id": 236220,
    "title": "Commercial and Institutional Building Construction",
    "display_name": "(236220) Commercial and Institutional Building Construction"
  },
  {
    "id": 237110,
    "title": "Water and Sewer Line and Related Structures Construction",
    "display_name": "(237110) Water and Sewer Line and Related Structures Construction"
  },
  {
    "id": 237120,
    "title": "Oil and Gas Pipeline and Related Structures Construction",
    "display_name": "(237120) Oil and Gas Pipeline and Related Structures Construction"
  },
  {
    "id": 237130,
    "title": "Power and Communication Line and Related Structures Construction",
    "display_name": "(237130) Power and Communication Line and Related Structures Construction"
  },
  {
    "id": 237210,
    "title": "Land Subdivision",
    "display_name": "(237210) Land Subdivision"
  },
  {
    "id": 237310,
    "title": "Highway, Street, and Bridge Construction",
    "display_name": "(237310) Highway, Street, and Bridge Construction"
  },
  {
    "id": 237990,
    "title": "Other Heavy and Civil Engineering Construction",
    "display_name": "(237990) Other Heavy and Civil Engineering Construction"
  },
  {
    "id": 238110,
    "title": "Poured Concrete Foundation and Structure Contractors",
    "display_name": "(238110) Poured Concrete Foundation and Structure Contractors"
  },
  {
    "id": 238120,
    "title": "Structural Steel and Precast Concrete Contractors",
    "display_name": "(238120) Structural Steel and Precast Concrete Contractors"
  },
  {
    "id": 238130,
    "title": "Framing Contractors",
    "display_name": "(238130) Framing Contractors"
  },
  {
    "id": 238140,
    "title": "Masonry Contractors",
    "display_name": "(238140) Masonry Contractors"
  },
  {
    "id": 238150,
    "title": "Glass and Glazing Contractors",
    "display_name": "(238150) Glass and Glazing Contractors"
  },
  {
    "id": 238160,
    "title": "Roofing Contractors",
    "display_name": "(238160) Roofing Contractors"
  },
  {
    "id": 238170,
    "title": "Siding Contractors",
    "display_name": "(238170) Siding Contractors"
  },
  {
    "id": 238190,
    "title": "Other Foundation, Structure, and Building Exterior Contractors",
    "display_name": "(238190) Other Foundation, Structure, and Building Exterior Contractors"
  },
  {
    "id": 238210,
    "title": "Electrical Contractors and Other Wiring Installation Contractors",
    "display_name": "(238210) Electrical Contractors and Other Wiring Installation Contractors"
  },
  {
    "id": 238220,
    "title": "Plumbing, Heating, and Air-Conditioning Contractors",
    "display_name": "(238220) Plumbing, Heating, and Air-Conditioning Contractors"
  },
  {
    "id": 238290,
    "title": "Other Building Equipment Contractors",
    "display_name": "(238290) Other Building Equipment Contractors"
  },
  {
    "id": 238310,
    "title": "Drywall and Insulation Contractors",
    "display_name": "(238310) Drywall and Insulation Contractors"
  },
  {
    "id": 238320,
    "title": "Painting and Wall Covering Contractors",
    "display_name": "(238320) Painting and Wall Covering Contractors"
  },
  {
    "id": 238330,
    "title": "Flooring Contractors",
    "display_name": "(238330) Flooring Contractors"
  },
  {
    "id": 238340,
    "title": "Tile and Terrazzo Contractors",
    "display_name": "(238340) Tile and Terrazzo Contractors"
  },
  {
    "id": 238350,
    "title": "Finish Carpentry Contractors",
    "display_name": "(238350) Finish Carpentry Contractors"
  },
  {
    "id": 238390,
    "title": "Other Building Finishing Contractors",
    "display_name": "(238390) Other Building Finishing Contractors"
  },
  {
    "id": 238910,
    "title": "Site Preparation Contractors",
    "display_name": "(238910) Site Preparation Contractors"
  },
  {
    "id": 238990,
    "title": "All Other Specialty Trade Contractors",
    "display_name": "(238990) All Other Specialty Trade Contractors"
  },


   {
    "id": 311111,
    "title": "Dog and Cat Food Manufacturing",
    "display_name": "(311111) Dog and Cat Food Manufacturing"
  },
  {
    "id": 311119,
    "title": "Other Animal Food Manufacturing",
    "display_name": "(311119) Other Animal Food Manufacturing"
  },
  {
    "id": 311211,
    "title": "Flour Milling",
    "display_name": "(311211) Flour Milling"
  },
  {
    "id": 311212,
    "title": "Rice Milling",
    "display_name": "(311212) Rice Milling"
  },
  {
    "id": 311213,
    "title": "Malt Manufacturing",
    "display_name": "(311213) Malt Manufacturing"
  },
  {
    "id": 311221,
    "title": "Wet Corn Milling and Starch Manufacturing",
    "display_name": "(311221) Wet Corn Milling and Starch Manufacturing"
  },
  {
    "id": 311224,
    "title": "Soybean and Other Oilseed Processing",
    "display_name": "(311224) Soybean and Other Oilseed Processing"
  },
  {
    "id": 311225,
    "title": "Fats and Oils Refining and Blending",
    "display_name": "(311225) Fats and Oils Refining and Blending"
  },
  {
    "id": 311230,
    "title": "Breakfast Cereal Manufacturing",
    "display_name": "(311230) Breakfast Cereal Manufacturing"
  },
  {
    "id": 311313,
    "title": "Beet Sugar Manufacturing",
    "display_name": "(311313) Beet Sugar Manufacturing"
  },
  {
    "id": 311314,
    "title": "Cane Sugar Manufacturing",
    "display_name": "(311314) Cane Sugar Manufacturing"
  },
  {
    "id": 311340,
    "title": "Nonchocolate Confectionery Manufacturing",
    "display_name": "(311340) Nonchocolate Confectionery Manufacturing"
  },
  {
    "id": 311351,
    "title": "Chocolate and Confectionery Manufacturing from Cacao Beans",
    "display_name": "(311351) Chocolate and Confectionery Manufacturing from Cacao Beans"
  },
  {
    "id": 311352,
    "title": "Confectionery Manufacturing from Purchased Chocolate",
    "display_name": "(311352) Confectionery Manufacturing from Purchased Chocolate"
  },
  {
    "id": 311411,
    "title": "Frozen Fruit, Juice, and Vegetable Manufacturing",
    "display_name": "(311411) Frozen Fruit, Juice, and Vegetable Manufacturing"
  },
  {
    "id": 311412,
    "title": "Frozen Specialty Food Manufacturing",
    "display_name": "(311412) Frozen Specialty Food Manufacturing"
  },
  {
    "id": 311421,
    "title": "Fruit and Vegetable Canning",
    "display_name": "(311421) Fruit and Vegetable Canning"
  },
  {
    "id": 311422,
    "title": "Specialty Canning",
    "display_name": "(311422) Specialty Canning"
  },
  {
    "id": 311423,
    "title": "Dried and Dehydrated Food Manufacturing",
    "display_name": "(311423) Dried and Dehydrated Food Manufacturing"
  },
  {
    "id": 311511,
    "title": "Fluid Milk Manufacturing",
    "display_name": "(311511) Fluid Milk Manufacturing"
  },
  {
    "id": 311512,
    "title": "Creamery Butter Manufacturing",
    "display_name": "(311512) Creamery Butter Manufacturing"
  },
  {
    "id": 311513,
    "title": "Cheese Manufacturing",
    "display_name": "(311513) Cheese Manufacturing"
  },
  {
    "id": 311514,
    "title": "Dry, Condensed, and Evaporated Dairy Product Manufacturing",
    "display_name": "(311514) Dry, Condensed, and Evaporated Dairy Product Manufacturing"
  },
  {
    "id": 311520,
    "title": "Ice Cream and Frozen Dessert Manufacturing",
    "display_name": "(311520) Ice Cream and Frozen Dessert Manufacturing"
  },
  {
    "id": 311611,
    "title": "Animal (except Poultry) Slaughtering",
    "display_name": "(311611) Animal (except Poultry) Slaughtering"
  },
  {
    "id": 311612,
    "title": "Meat Processed from Carcasses",
    "display_name": "(311612) Meat Processed from Carcasses"
  },
  {
    "id": 311613,
    "title": "Rendering and Meat Byproduct Processing",
    "display_name": "(311613) Rendering and Meat Byproduct Processing"
  },
  {
    "id": 311615,
    "title": "Poultry Processing",
    "display_name": "(311615) Poultry Processing"
  },
  {
    "id": 311710,
    "title": "Seafood Product Preparation and Packaging",
    "display_name": "(311710) Seafood Product Preparation and Packaging"
  },
  {
    "id": 311811,
    "title": "Retail Bakeries",
    "display_name": "(311811) Retail Bakeries"
  },
  {
    "id": 311812,
    "title": "Commercial Bakeries",
    "display_name": "(311812) Commercial Bakeries"
  },
  {
    "id": 311813,
    "title": "Frozen Cakes, Pies, and Other Pastries Manufacturing",
    "display_name": "(311813) Frozen Cakes, Pies, and Other Pastries Manufacturing"
  },
  {
    "id": 311821,
    "title": "Cookie and Cracker Manufacturing",
    "display_name": "(311821) Cookie and Cracker Manufacturing"
  },
  {
    "id": 311824,
    "title": "Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour",
    "display_name": "(311824) Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour"
  },
  {
    "id": 311830,
    "title": "Tortilla Manufacturing",
    "display_name": "(311830) Tortilla Manufacturing"
  },
  {
    "id": 311911,
    "title": "Roasted Nuts and Peanut Butter Manufacturing",
    "display_name": "(311911) Roasted Nuts and Peanut Butter Manufacturing"
  },
  {
    "id": 311919,
    "title": "Other Snack Food Manufacturing",
    "display_name": "(311919) Other Snack Food Manufacturing"
  },
  {
    "id": 311920,
    "title": "Coffee and Tea Manufacturing",
    "display_name": "(311920) Coffee and Tea Manufacturing"
  },
  {
    "id": 311930,
    "title": "Flavoring Syrup and Concentrate Manufacturing",
    "display_name": "(311930) Flavoring Syrup and Concentrate Manufacturing"
  },
  {
    "id": 311941,
    "title": "Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing",
    "display_name": "(311941) Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing"
  },
  {
    "id": 311942,
    "title": "Spice and Extract Manufacturing",
    "display_name": "(311942) Spice and Extract Manufacturing"
  },
  {
    "id": 311991,
    "title": "Perishable Prepared Food Manufacturing",
    "display_name": "(311991) Perishable Prepared Food Manufacturing"
  },
  {
    "id": 311999,
    "title": "All Other Miscellaneous Food Manufacturing",
    "display_name": "(311999) All Other Miscellaneous Food Manufacturing"
  },

    {
    "id": 312111,
    "title": "Soft Drink Manufacturing",
    "display_name": "(312111) Soft Drink Manufacturing"
  },
  {
    "id": 312112,
    "title": "Bottled Water Manufacturing",
    "display_name": "(312112) Bottled Water Manufacturing"
  },
  {
    "id": 312113,
    "title": "Ice Manufacturing",
    "display_name": "(312113) Ice Manufacturing"
  },
  {
    "id": 312120,
    "title": "Breweries",
    "display_name": "(312120) Breweries"
  },
  {
    "id": 312130,
    "title": "Wineries",
    "display_name": "(312130) Wineries"
  },
  {
    "id": 312140,
    "title": "Distilleries",
    "display_name": "(312140) Distilleries"
  },
  {
    "id": 312230,
    "title": "Tobacco Manufacturing",
    "display_name": "(312230) Tobacco Manufacturing"
  },
  {
    "id": 313110,
    "title": "Fiber, Yarn, and Thread Mills",
    "display_name": "(313110) Fiber, Yarn, and Thread Mills"
  },
  {
    "id": 313210,
    "title": "Broadwoven Fabric Mills",
    "display_name": "(313210) Broadwoven Fabric Mills"
  },
  {
    "id": 313220,
    "title": "Narrow Fabric Mills and Schiffli Machine Embroidery",
    "display_name": "(313220) Narrow Fabric Mills and Schiffli Machine Embroidery"
  },
  {
    "id": 313230,
    "title": "Nonwoven Fabric Mills",
    "display_name": "(313230) Nonwoven Fabric Mills"
  },
  {
    "id": 313240,
    "title": "Knit Fabric Mills",
    "display_name": "(313240) Knit Fabric Mills"
  },
  {
    "id": 313310,
    "title": "Textile and Fabric Finishing Mills",
    "display_name": "(313310) Textile and Fabric Finishing Mills"
  },
  {
    "id": 313320,
    "title": "Fabric Coating Mills",
    "display_name": "(313320) Fabric Coating Mills"
  },
  {
    "id": 314110,
    "title": "Carpet and Rug Mills",
    "display_name": "(314110) Carpet and Rug Mills"
  },
  {
    "id": 314120,
    "title": "Curtain and Linen Mills",
    "display_name": "(314120) Curtain and Linen Mills"
  },
  {
    "id": 314910,
    "title": "Textile Bag and Canvas Mills",
    "display_name": "(314910) Textile Bag and Canvas Mills"
  },
  {
    "id": 314994,
    "title": "Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills",
    "display_name": "(314994) Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills"
  },
  {
    "id": 314999,
    "title": "All Other Miscellaneous Textile Product Mills",
    "display_name": "(314999) All Other Miscellaneous Textile Product Mills"
  },
  {
    "id": 315120,
    "title": "Apparel Knitting Mills",
    "display_name": "(315120) Apparel Knitting Mills"
  },
  {
    "id": 315250,
    "title": "Cut and Sew Apparel Manufacturing (except Contractors)",
    "display_name": "(315250) Cut and Sew Apparel Manufacturing (except Contractors)"
  },
  {
    "id": 315990,
    "title": "Apparel Accessories and Other Apparel Manufacturing",
    "display_name": "(315990) Apparel Accessories and Other Apparel Manufacturing"
  },
  {
    "id": 316110,
    "title": "Leather and Hide Tanning and Finishing",
    "display_name": "(316110) Leather and Hide Tanning and Finishing"
  },
  {
    "id": 316210,
    "title": "Footwear Manufacturing",
    "display_name": "(316210) Footwear Manufacturing"
  },
  {
    "id": 316990,
    "title": "Other Leather and Allied Product Manufacturing",
    "display_name": "(316990) Other Leather and Allied Product Manufacturing"
  },
  {
    "id": 321113,
    "title": "Sawmills",
    "display_name": "(321113) Sawmills"
  },
  {
    "id": 321114,
    "title": "Wood Preservation",
    "display_name": "(321114) Wood Preservation"
  },
  {
    "id": 321211,
    "title": "Hardwood Veneer and Plywood Manufacturing",
    "display_name": "(321211) Hardwood Veneer and Plywood Manufacturing"
  },
  {
    "id": 321212,
    "title": "Softwood Veneer and Plywood Manufacturing",
    "display_name": "(321212) Softwood Veneer and Plywood Manufacturing"
  },
  {
    "id": 321215,
    "title": "Engineered Wood Member Manufacturing",
    "display_name": "(321215) Engineered Wood Member Manufacturing"
  },
  {
    "id": 321219,
    "title": "Reconstituted Wood Product Manufacturing",
    "display_name": "(321219) Reconstituted Wood Product Manufacturing"
  },
  {
    "id": 321911,
    "title": "Wood Window and Door Manufacturing",
    "display_name": "(321911) Wood Window and Door Manufacturing"
  },
  {
    "id": 321912,
    "title": "Cut Stock, Resawing Lumber, and Planing",
    "display_name": "(321912) Cut Stock, Resawing Lumber, and Planing"
  },
  {
    "id": 321918,
    "title": "Other Millwork (including Flooring)",
    "display_name": "(321918) Other Millwork (including Flooring)"
  },
  {
    "id": 321920,
    "title": "Wood Container and Pallet Manufacturing",
    "display_name": "(321920) Wood Container and Pallet Manufacturing"
  },
  {
    "id": 321991,
    "title": "Manufactured Home (Mobile Home) Manufacturing",
    "display_name": "(321991) Manufactured Home (Mobile Home) Manufacturing"
  },
  {
    "id": 321992,
    "title": "Prefabricated Wood Building Manufacturing",
    "display_name": "(321992) Prefabricated Wood Building Manufacturing"
  },
  {
    "id": 321999,
    "title": "All Other Miscellaneous Wood Product Manufacturing",
    "display_name": "(321999) All Other Miscellaneous Wood Product Manufacturing"
  },

  {
    "id": 326211,
    "title": "Tire Manufacturing (except Retreading)",
    "display_name": "(326211) Tire Manufacturing (except Retreading)"
  },
  {
    "id": 326212,
    "title": "Tire Retreading",
    "display_name": "(326212) Tire Retreading"
  },
  {
    "id": 326220,
    "title": "Rubber and Plastics Hoses and Belting Manufacturing",
    "display_name": "(326220) Rubber and Plastics Hoses and Belting Manufacturing"
  },
  {
    "id": 326291,
    "title": "Rubber Product Manufacturing for Mechanical Use",
    "display_name": "(326291) Rubber Product Manufacturing for Mechanical Use"
  },
  {
    "id": 326299,
    "title": "All Other Rubber Product Manufacturing",
    "display_name": "(326299) All Other Rubber Product Manufacturing"
  },
  {
    "id": 327110,
    "title": "Pottery, Ceramics, and Plumbing Fixture Manufacturing",
    "display_name": "(327110) Pottery, Ceramics, and Plumbing Fixture Manufacturing"
  },
  {
    "id": 327120,
    "title": "Clay Building Material and Refractories Manufacturing",
    "display_name": "(327120) Clay Building Material and Refractories Manufacturing"
  },
  {
    "id": 327211,
    "title": "Flat Glass Manufacturing",
    "display_name": "(327211) Flat Glass Manufacturing"
  },
  {
    "id": 327212,
    "title": "Other Pressed and Blown Glass and Glassware Manufacturing",
    "display_name": "(327212) Other Pressed and Blown Glass and Glassware Manufacturing"
  },
  {
    "id": 327213,
    "title": "Glass Container Manufacturing",
    "display_name": "(327213) Glass Container Manufacturing"
  },
  {
    "id": 327215,
    "title": "Glass Product Manufacturing Made of Purchased Glass",
    "display_name": "(327215) Glass Product Manufacturing Made of Purchased Glass"
  },
  {
    "id": 327310,
    "title": "Cement Manufacturing",
    "display_name": "(327310) Cement Manufacturing"
  },
  {
    "id": 327320,
    "title": "Ready-Mix Concrete Manufacturing",
    "display_name": "(327320) Ready-Mix Concrete Manufacturing"
  },
  {
    "id": 327331,
    "title": "Concrete Block and Brick Manufacturing",
    "display_name": "(327331) Concrete Block and Brick Manufacturing"
  },
  {
    "id": 327332,
    "title": "Concrete Pipe Manufacturing",
    "display_name": "(327332) Concrete Pipe Manufacturing"
  },
  {
    "id": 327390,
    "title": "Other Concrete Product Manufacturing",
    "display_name": "(327390) Other Concrete Product Manufacturing"
  },
  {
    "id": 327410,
    "title": "Lime Manufacturing",
    "display_name": "(327410) Lime Manufacturing"
  },
  {
    "id": 327420,
    "title": "Gypsum Product Manufacturing",
    "display_name": "(327420) Gypsum Product Manufacturing"
  },
  {
    "id": 327910,
    "title": "Abrasive Product Manufacturing",
    "display_name": "(327910) Abrasive Product Manufacturing"
  },
  {
    "id": 327991,
    "title": "Cut Stone and Stone Product Manufacturing",
    "display_name": "(327991) Cut Stone and Stone Product Manufacturing"
  },
  {
    "id": 327992,
    "title": "Ground or Treated Mineral and Earth Manufacturing",
    "display_name": "(327992) Ground or Treated Mineral and Earth Manufacturing"
  },
  {
    "id": 327993,
    "title": "Mineral Wool Manufacturing",
    "display_name": "(327993) Mineral Wool Manufacturing"
  },
  {
    "id": 327999,
    "title": "All Other Miscellaneous Nonmetallic Mineral Product Manufacturing",
    "display_name": "(327999) All Other Miscellaneous Nonmetallic Mineral Product Manufacturing"
  },
  {
    "id": 331110,
    "title": "Iron and Steel Mills and Ferroalloy Manufacturing",
    "display_name": "(331110) Iron and Steel Mills and Ferroalloy Manufacturing"
  },
  {
    "id": 331210,
    "title": "Iron and Steel Pipe and Tube Manufacturing from Purchased Steel",
    "display_name": "(331210) Iron and Steel Pipe and Tube Manufacturing from Purchased Steel"
  },
  {
    "id": 331221,
    "title": "Rolled Steel Shape Manufacturing",
    "display_name": "(331221) Rolled Steel Shape Manufacturing"
  },
  {
    "id": 331222,
    "title": "Steel Wire Drawing",
    "display_name": "(331222) Steel Wire Drawing"
  },
  {
    "id": 331313,
    "title": "Alumina Refining and Primary Aluminum Production",
    "display_name": "(331313) Alumina Refining and Primary Aluminum Production"
  },
  {
    "id": 331314,
    "title": "Secondary Smelting and Alloying of Aluminum",
    "display_name": "(331314) Secondary Smelting and Alloying of Aluminum"
  },
  {
    "id": 331315,
    "title": "Aluminum Sheet, Plate, and Foil Manufacturing",
    "display_name": "(331315) Aluminum Sheet, Plate, and Foil Manufacturing"
  },
  {
    "id": 331318,
    "title": "Other Aluminum Rolling, Drawing, and Extruding",
    "display_name": "(331318) Other Aluminum Rolling, Drawing, and Extruding"
  },
  {
    "id": 331410,
    "title": "Nonferrous Metal (except Aluminum) Smelting and Refining",
    "display_name": "(331410) Nonferrous Metal (except Aluminum) Smelting and Refining"
  },
  {
    "id": 331420,
    "title": "Copper Rolling, Drawing, Extruding, and Alloying",
    "display_name": "(331420) Copper Rolling, Drawing, Extruding, and Alloying"
  },
  {
    "id": 331491,
    "title": "Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding",
    "display_name": "(331491) Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding"
  },
  {
    "id": 331492,
    "title": "Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)",
    "display_name": "(331492) Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)"
  },
  {
    "id": 331511,
    "title": "Iron Foundries",
    "display_name": "(331511) Iron Foundries"
  },
  {
    "id": 331512,
    "title": "Steel Investment Foundries",
    "display_name": "(331512) Steel Investment Foundries"
  },
  {
    "id": 331513,
    "title": "Steel Foundries (except Investment)",
    "display_name": "(331513) Steel Foundries (except Investment)"
  },
  {
    "id": 331523,
    "title": "Nonferrous Metal Die-Casting Foundries",
    "display_name": "(331523) Nonferrous Metal Die-Casting Foundries"
  },
  {
    "id": 331524,
    "title": "Aluminum Foundries (except Die-Casting)",
    "display_name": "(331524) Aluminum Foundries (except Die-Casting)"
  },
  {
    "id": 331529,
    "title": "Other Nonferrous Metal Foundries (except Die-Casting)",
    "display_name": "(331529) Other Nonferrous Metal Foundries (except Die-Casting)"
  },
  {
    "id": 332111,
    "title": "Iron and Steel Forging",
    "display_name": "(332111) Iron and Steel Forging"
  },
  {
    "id": 332112,
    "title": "Nonferrous Forging",
    "display_name": "(332112) Nonferrous Forging"
  },
  {
    "id": 332114,
    "title": "Custom Roll Forming",
    "display_name": "(332114) Custom Roll Forming"
  },
  {
    "id": 332117,
    "title": "Powder Metallurgy Part Manufacturing",
    "display_name": "(332117) Powder Metallurgy Part Manufacturing"
  },
  {
    "id": 332119,
    "title": "Metal Crown, Closure, and Other Metal Stamping (except Automotive)",
    "display_name": "(332119) Metal Crown, Closure, and Other Metal Stamping (except Automotive)"
  },
  {
    "id": 332215,
    "title": "Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing",
    "display_name": "(332215) Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing"
  },
  {
    "id": 332216,
    "title": "Saw Blade and Handtool Manufacturing",
    "display_name": "(332216) Saw Blade and Handtool Manufacturing"
  },

   {
    "id": 332311,
    "title": "Prefabricated Metal Building and Component Manufacturing",
    "display_name": "(332311) Prefabricated Metal Building and Component Manufacturing"
  },
  {
    "id": 332312,
    "title": "Fabricated Structural Metal Manufacturing",
    "display_name": "(332312) Fabricated Structural Metal Manufacturing"
  },
  {
    "id": 332313,
    "title": "Plate Work Manufacturing",
    "display_name": "(332313) Plate Work Manufacturing"
  },
  {
    "id": 332321,
    "title": "Metal Window and Door Manufacturing",
    "display_name": "(332321) Metal Window and Door Manufacturing"
  },
  {
    "id": 332322,
    "title": "Sheet Metal Work Manufacturing",
    "display_name": "(332322) Sheet Metal Work Manufacturing"
  },
  {
    "id": 332323,
    "title": "Ornamental and Architectural Metal Work Manufacturing",
    "display_name": "(332323) Ornamental and Architectural Metal Work Manufacturing"
  },
  {
    "id": 332410,
    "title": "Power Boiler and Heat Exchanger Manufacturing",
    "display_name": "(332410) Power Boiler and Heat Exchanger Manufacturing"
  },
  {
    "id": 332420,
    "title": "Metal Tank (Heavy Gauge) Manufacturing",
    "display_name": "(332420) Metal Tank (Heavy Gauge) Manufacturing"
  },
  {
    "id": 332431,
    "title": "Metal Can Manufacturing",
    "display_name": "(332431) Metal Can Manufacturing"
  },
  {
    "id": 332439,
    "title": "Other Metal Container Manufacturing",
    "display_name": "(332439) Other Metal Container Manufacturing"
  },
  {
    "id": 332510,
    "title": "Hardware Manufacturing",
    "display_name": "(332510) Hardware Manufacturing"
  },
  {
    "id": 332613,
    "title": "Spring Manufacturing",
    "display_name": "(332613) Spring Manufacturing"
  },
  {
    "id": 332618,
    "title": "Other Fabricated Wire Product Manufacturing",
    "display_name": "(332618) Other Fabricated Wire Product Manufacturing"
  },
  {
    "id": 332710,
    "title": "Machine Shops",
    "display_name": "(332710) Machine Shops"
  },
  {
    "id": 332721,
    "title": "Precision Turned Product Manufacturing",
    "display_name": "(332721) Precision Turned Product Manufacturing"
  },
  {
    "id": 332722,
    "title": "Bolt, Nut, Screw, Rivet, and Washer Manufacturing",
    "display_name": "(332722) Bolt, Nut, Screw, Rivet, and Washer Manufacturing"
  },
  {
    "id": 332811,
    "title": "Metal Heat Treating",
    "display_name": "(332811) Metal Heat Treating"
  },
  {
    "id": 332812,
    "title": "Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers",
    "display_name": "(332812) Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers"
  },
  {
    "id": 332813,
    "title": "Electroplating, Plating, Polishing, Anodizing, and Coloring",
    "display_name": "(332813) Electroplating, Plating, Polishing, Anodizing, and Coloring"
  },
  {
    "id": 332911,
    "title": "Industrial Valve Manufacturing",
    "display_name": "(332911) Industrial Valve Manufacturing"
  },
  {
    "id": 332912,
    "title": "Fluid Power Valve and Hose Fitting Manufacturing",
    "display_name": "(332912) Fluid Power Valve and Hose Fitting Manufacturing"
  },
  {
    "id": 332913,
    "title": "Plumbing Fixture Fitting and Trim Manufacturing",
    "display_name": "(332913) Plumbing Fixture Fitting and Trim Manufacturing"
  },
  {
    "id": 332919,
    "title": "Other Metal Valve and Pipe Fitting Manufacturing",
    "display_name": "(332919) Other Metal Valve and Pipe Fitting Manufacturing"
  },
  {
    "id": 332991,
    "title": "Ball and Roller Bearing Manufacturing",
    "display_name": "(332991) Ball and Roller Bearing Manufacturing"
  },
  {
    "id": 332992,
    "title": "Small Arms Ammunition Manufacturing",
    "display_name": "(332992) Small Arms Ammunition Manufacturing"
  },
  {
    "id": 332993,
    "title": "Ammunition (except Small Arms) Manufacturing",
    "display_name": "(332993) Ammunition (except Small Arms) Manufacturing"
  },
  {
    "id": 332994,
    "title": "Small Arms, Ordnance, and Ordnance Accessories Manufacturing",
    "display_name": "(332994) Small Arms, Ordnance, and Ordnance Accessories Manufacturing"
  },
  {
    "id": 332996,
    "title": "Fabricated Pipe and Pipe Fitting Manufacturing",
    "display_name": "(332996) Fabricated Pipe and Pipe Fitting Manufacturing"
  },
  {
    "id": 332999,
    "title": "All Other Miscellaneous Fabricated Metal Product Manufacturing",
    "display_name": "(332999) All Other Miscellaneous Fabricated Metal Product Manufacturing"
  },
  {
    "id": 333111,
    "title": "Farm Machinery and Equipment Manufacturing",
    "display_name": "(333111) Farm Machinery and Equipment Manufacturing"
  },
  {
    "id": 333112,
    "title": "Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing",
    "display_name": "(333112) Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing"
  },
  {
    "id": 333120,
    "title": "Construction Machinery Manufacturing",
    "display_name": "(333120) Construction Machinery Manufacturing"
  },
  {
    "id": 333131,
    "title": "Mining Machinery and Equipment Manufacturing",
    "display_name": "(333131) Mining Machinery and Equipment Manufacturing"
  },
  {
    "id": 333132,
    "title": "Oil and Gas Field Machinery and Equipment Manufacturing",
    "display_name": "(333132) Oil and Gas Field Machinery and Equipment Manufacturing"
  },
  {
    "id": 333241,
    "title": "Food Product Machinery Manufacturing",
    "display_name": "(333241) Food Product Machinery Manufacturing"
  },
  {
    "id": 333242,
    "title": "Semiconductor Machinery Manufacturing",
    "display_name": "(333242) Semiconductor Machinery Manufacturing"
  },
  {
    "id": 333243,
    "title": "Sawmill, Woodworking, and Paper Machinery Manufacturing",
    "display_name": "(333243) Sawmill, Woodworking, and Paper Machinery Manufacturing"
  },
  {
    "id": 333248,
    "title": "All Other Industrial Machinery Manufacturing",
    "display_name": "(333248) All Other Industrial Machinery Manufacturing"
  },
  {
    "id": 333310,
    "title": "Commercial and Service Industry Machinery Manufacturing",
    "display_name": "(333310) Commercial and Service Industry Machinery Manufacturing"
  },
  {
    "id": 333413,
    "title": "Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing",
    "display_name": "(333413) Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing"
  },
  {
    "id": 333414,
    "title": "Heating Equipment (except Warm Air Furnaces) Manufacturing",
    "display_name": "(333414) Heating Equipment (except Warm Air Furnaces) Manufacturing"
  },
  {
    "id": 333415,
    "title": "Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing",
    "display_name": "(333415) Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing"
  },
  {
    "id": 333511,
    "title": "Industrial Mold Manufacturing",
    "display_name": "(333511) Industrial Mold Manufacturing"
  },
  {
    "id": 333514,
    "title": "Special Die and Tool, Die Set, Jig, and Fixture Manufacturing",
    "display_name": "(333514) Special Die and Tool, Die Set, Jig, and Fixture Manufacturing"
  },
  {
    "id": 333515,
    "title": "Cutting Tool and Machine Tool Accessory Manufacturing",
    "display_name": "(333515) Cutting Tool and Machine Tool Accessory Manufacturing"
  },
  {
    "id": 333517,
    "title": "Machine Tool Manufacturing",
    "display_name": "(333517) Machine Tool Manufacturing"
  },
  {
    "id": 333519,
    "title": "Rolling Mill and Other Metalworking Machinery Manufacturing",
    "display_name": "(333519) Rolling Mill and Other Metalworking Machinery Manufacturing"
  },

    {
    "id": 334111,
    "title": "Electronic Computer Manufacturing",
    "display_name": "(334111) Electronic Computer Manufacturing"
  },
  {
    "id": 334112,
    "title": "Computer Storage Device Manufacturing",
    "display_name": "(334112) Computer Storage Device Manufacturing"
  },
  {
    "id": 334118,
    "title": "Computer Terminal and Other Computer Peripheral Equipment Manufacturing",
    "display_name": "(334118) Computer Terminal and Other Computer Peripheral Equipment Manufacturing"
  },
  {
    "id": 334210,
    "title": "Telephone Apparatus Manufacturing",
    "display_name": "(334210) Telephone Apparatus Manufacturing"
  },
  {
    "id": 334220,
    "title": "Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing",
    "display_name": "(334220) Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing"
  },
  {
    "id": 334290,
    "title": "Other Communications Equipment Manufacturing",
    "display_name": "(334290) Other Communications Equipment Manufacturing"
  },
  {
    "id": 334310,
    "title": "Audio and Video Equipment Manufacturing",
    "display_name": "(334310) Audio and Video Equipment Manufacturing"
  },
  {
    "id": 334412,
    "title": "Bare Printed Circuit Board Manufacturing",
    "display_name": "(334412) Bare Printed Circuit Board Manufacturing"
  },
  {
    "id": 334413,
    "title": "Semiconductor and Related Device Manufacturing",
    "display_name": "(334413) Semiconductor and Related Device Manufacturing"
  },
  {
    "id": 334416,
    "title": "Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing",
    "display_name": "(334416) Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing"
  },
  {
    "id": 334417,
    "title": "Electronic Connector Manufacturing",
    "display_name": "(334417) Electronic Connector Manufacturing"
  },
  {
    "id": 334418,
    "title": "Printed Circuit Assembly (Electronic Assembly) Manufacturing",
    "display_name": "(334418) Printed Circuit Assembly (Electronic Assembly) Manufacturing"
  },
  {
    "id": 334419,
    "title": "Other Electronic Component Manufacturing",
    "display_name": "(334419) Other Electronic Component Manufacturing"
  },
  {
    "id": 334510,
    "title": "Electromedical and Electrotherapeutic Apparatus Manufacturing",
    "display_name": "(334510) Electromedical and Electrotherapeutic Apparatus Manufacturing"
  },
  {
    "id": 334511,
    "title": "Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing",
    "display_name": "(334511) Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing"
  },
  {
    "id": 334512,
    "title": "Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use",
    "display_name": "(334512) Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use"
  },
  {
    "id": 334513,
    "title": "Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables",
    "display_name": "(334513) Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables"
  },
  {
    "id": 334514,
    "title": "Totalizing Fluid Meter and Counting Device Manufacturing",
    "display_name": "(334514) Totalizing Fluid Meter and Counting Device Manufacturing"
  },
  {
    "id": 334515,
    "title": "Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals",
    "display_name": "(334515) Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals"
  },
  {
    "id": 334516,
    "title": "Analytical Laboratory Instrument Manufacturing",
    "display_name": "(334516) Analytical Laboratory Instrument Manufacturing"
  },
  {
    "id": 334517,
    "title": "Irradiation Apparatus Manufacturing",
    "display_name": "(334517) Irradiation Apparatus Manufacturing"
  },
  {
    "id": 334519,
    "title": "Other Measuring and Controlling Device Manufacturing",
    "display_name": "(334519) Other Measuring and Controlling Device Manufacturing"
  },
  {
    "id": 334610,
    "title": "Manufacturing and Reproducing Magnetic and Optical Media",
    "display_name": "(334610) Manufacturing and Reproducing Magnetic and Optical Media"
  },
  {
    "id": 335131,
    "title": "Residential Electric Lighting Fixture Manufacturing",
    "display_name": "(335131) Residential Electric Lighting Fixture Manufacturing"
  },
  {
    "id": 335132,
    "title": "Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing",
    "display_name": "(335132) Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing"
  },
  {
    "id": 335139,
    "title": "Electric Lamp Bulb and Other Lighting Equipment Manufacturing",
    "display_name": "(335139) Electric Lamp Bulb and Other Lighting Equipment Manufacturing"
  },
  {
    "id": 335210,
    "title": "Small Electrical Appliance Manufacturing",
    "display_name": "(335210) Small Electrical Appliance Manufacturing"
  },
  {
    "id": 335220,
    "title": "Major Household Appliance Manufacturing",
    "display_name": "(335220) Major Household Appliance Manufacturing"
  },
  {
    "id": 335311,
    "title": "Power, Distribution, and Specialty Transformer Manufacturing",
    "display_name": "(335311) Power, Distribution, and Specialty Transformer Manufacturing"
  },
  {
    "id": 335312,
    "title": "Motor and Generator Manufacturing",
    "display_name": "(335312) Motor and Generator Manufacturing"
  },
  {
    "id": 335313,
    "title": "Switchgear and Switchboard Apparatus Manufacturing",
    "display_name": "(335313) Switchgear and Switchboard Apparatus Manufacturing"
  },
  {
    "id": 335314,
    "title": "Relay and Industrial Control Manufacturing",
    "display_name": "(335314) Relay and Industrial Control Manufacturing"
  },
  {
    "id": 335910,
    "title": "Battery Manufacturing",
    "display_name": "(335910) Battery Manufacturing"
  },
  {
    "id": 335921,
    "title": "Fiber Optic Cable Manufacturing",
    "display_name": "(335921) Fiber Optic Cable Manufacturing"
  },
  {
    "id": 335929,
    "title": "Other Communication and Energy Wire Manufacturing",
    "display_name": "(335929) Other Communication and Energy Wire Manufacturing"
  },
  {
    "id": 335931,
    "title": "Current-Carrying Wiring Device Manufacturing",
    "display_name": "(335931) Current-Carrying Wiring Device Manufacturing"
  },
  {
    "id": 335932,
    "title": "Noncurrent-Carrying Wiring Device Manufacturing",
    "display_name": "(335932) Noncurrent-Carrying Wiring Device Manufacturing"
  },
  {
    "id": 335991,
    "title": "Carbon and Graphite Product Manufacturing",
    "display_name": "(335991) Carbon and Graphite Product Manufacturing"
  },
  {
    "id": 335999,
    "title": "All Other Miscellaneous Electrical Equipment and Component Manufacturing",
    "display_name": "(335999) All Other Miscellaneous Electrical Equipment and Component Manufacturing"
  },
  {
    "id": 336110,
    "title": "Automobile and Light Duty Motor Vehicle Manufacturing",
    "display_name": "(336110) Automobile and Light Duty Motor Vehicle Manufacturing"
  },
  {
    "id": 336120,
    "title": "Heavy Duty Truck Manufacturing",
    "display_name": "(336120) Heavy Duty Truck Manufacturing"
  },
  {
    "id": 336211,
    "title": "Motor Vehicle Body Manufacturing",
    "display_name": "(336211) Motor Vehicle Body Manufacturing"
  },
  {
    "id": 336212,
    "title": "Truck Trailer Manufacturing",
    "display_name": "(336212) Truck Trailer Manufacturing"
  },
  {
    "id": 336213,
    "title": "Motor Home Manufacturing",
    "display_name": "(336213) Motor Home Manufacturing"
  },
  {
    "id": 336214,
    "title": "Travel Trailer and Camper Manufacturing",
    "display_name": "(336214) Travel Trailer and Camper Manufacturing"
  },
  {
    "id": 336310,
    "title": "Motor Vehicle Gasoline Engine and Engine Parts Manufacturing",
    "display_name": "(336310) Motor Vehicle Gasoline Engine and Engine Parts Manufacturing"
  },
  {
    "id": 336320,
    "title": "Motor Vehicle Electrical and Electronic Equipment Manufacturing",
    "display_name": "(336320) Motor Vehicle Electrical and Electronic Equipment Manufacturing"
  },
  {
    "id": 336330,
    "title": "Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing",
    "display_name": "(336330) Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing"
  },
  {
    "id": 336340,
    "title": "Motor Vehicle Brake System Manufacturing",
    "display_name": "(336340) Motor Vehicle Brake System Manufacturing"
  },
  {
    "id": 336350,
    "title": "Motor Vehicle Transmission and Power Train Parts Manufacturing",
    "display_name": "(336350) Motor Vehicle Transmission and Power Train Parts Manufacturing"
  },
  {
    "id": 336360,
    "title": "Motor Vehicle Seating and Interior Trim Manufacturing",
    "display_name": "(336360) Motor Vehicle Seating and Interior Trim Manufacturing"
  },
  {
    "id": 336370,
    "title": "Motor Vehicle Metal Stamping",
    "display_name": "(336370) Motor Vehicle Metal Stamping"
  },
  {
    "id": 336390,
    "title": "Other Motor Vehicle Parts Manufacturing",
    "display_name": "(336390) Other Motor Vehicle Parts Manufacturing"
  },

  {
    "id": 336411,
    "title": "Aircraft Manufacturing",
    "display_name": "(336411) Aircraft Manufacturing"
  },
  {
    "id": 336412,
    "title": "Aircraft Engine and Engine Parts Manufacturing",
    "display_name": "(336412) Aircraft Engine and Engine Parts Manufacturing"
  },
  {
    "id": 336413,
    "title": "Other Aircraft Parts and Auxiliary Equipment Manufacturing",
    "display_name": "(336413) Other Aircraft Parts and Auxiliary Equipment Manufacturing"
  },
  {
    "id": 336414,
    "title": "Guided Missile and Space Vehicle Manufacturing",
    "display_name": "(336414) Guided Missile and Space Vehicle Manufacturing"
  },
  {
    "id": 336415,
    "title": "Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing",
    "display_name": "(336415) Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing"
  },
  {
    "id": 336419,
    "title": "Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing",
    "display_name": "(336419) Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing"
  },
  {
    "id": 336510,
    "title": "Railroad Rolling Stock Manufacturing",
    "display_name": "(336510) Railroad Rolling Stock Manufacturing"
  },
  {
    "id": 336611,
    "title": "Ship Building and Repairing",
    "display_name": "(336611) Ship Building and Repairing"
  },
  {
    "id": 336612,
    "title": "Boat Building",
    "display_name": "(336612) Boat Building"
  },
  {
    "id": 336991,
    "title": "Motorcycle, Bicycle, and Parts Manufacturing",
    "display_name": "(336991) Motorcycle, Bicycle, and Parts Manufacturing"
  },
  {
    "id": 336992,
    "title": "Military Armored Vehicle, Tank, and Tank Component Manufacturing",
    "display_name": "(336992) Military Armored Vehicle, Tank, and Tank Component Manufacturing"
  },
  {
    "id": 336999,
    "title": "All Other Transportation Equipment Manufacturing",
    "display_name": "(336999) All Other Transportation Equipment Manufacturing"
  },
  {
    "id": 337110,
    "title": "Wood Kitchen Cabinet and Countertop Manufacturing",
    "display_name": "(337110) Wood Kitchen Cabinet and Countertop Manufacturing"
  },
  {
    "id": 337121,
    "title": "Upholstered Household Furniture Manufacturing",
    "display_name": "(337121) Upholstered Household Furniture Manufacturing"
  },
  {
    "id": 337122,
    "title": "Nonupholstered Wood Household Furniture Manufacturing",
    "display_name": "(337122) Nonupholstered Wood Household Furniture Manufacturing"
  },
  {
    "id": 337126,
    "title": "Household Furniture (except Wood and Upholstered) Manufacturing",
    "display_name": "(337126) Household Furniture (except Wood and Upholstered) Manufacturing"
  },
  {
    "id": 337127,
    "title": "Institutional Furniture Manufacturing",
    "display_name": "(337127) Institutional Furniture Manufacturing"
  },
  {
    "id": 337211,
    "title": "Wood Office Furniture Manufacturing",
    "display_name": "(337211) Wood Office Furniture Manufacturing"
  },
  {
    "id": 337212,
    "title": "Custom Architectural Woodwork and Millwork Manufacturing",
    "display_name": "(337212) Custom Architectural Woodwork and Millwork Manufacturing"
  },
  {
    "id": 337214,
    "title": "Office Furniture (except Wood) Manufacturing",
    "display_name": "(337214) Office Furniture (except Wood) Manufacturing"
  },
  {
    "id": 337215,
    "title": "Showcase, Partition, Shelving, and Locker Manufacturing",
    "display_name": "(337215) Showcase, Partition, Shelving, and Locker Manufacturing"
  },
  {
    "id": 337910,
    "title": "Mattress Manufacturing",
    "display_name": "(337910) Mattress Manufacturing"
  },
  {
    "id": 337920,
    "title": "Blind and Shade Manufacturing",
    "display_name": "(337920) Blind and Shade Manufacturing"
  },
  {
    "id": 339112,
    "title": "Surgical and Medical Instrument Manufacturing",
    "display_name": "(339112) Surgical and Medical Instrument Manufacturing"
  },
  {
    "id": 339113,
    "title": "Surgical Appliance and Supplies Manufacturing",
    "display_name": "(339113) Surgical Appliance and Supplies Manufacturing"
  },
  {
    "id": 339114,
    "title": "Dental Equipment and Supplies Manufacturing",
    "display_name": "(339114) Dental Equipment and Supplies Manufacturing"
  },
  {
    "id": 339115,
    "title": "Ophthalmic Goods Manufacturing",
    "display_name": "(339115) Ophthalmic Goods Manufacturing"
  },
  {
    "id": 339116,
    "title": "Dental Laboratories",
    "display_name": "(339116) Dental Laboratories"
  },
  {
    "id": 339910,
    "title": "Jewelry and Silverware Manufacturing",
    "display_name": "(339910) Jewelry and Silverware Manufacturing"
  },
  {
    "id": 339920,
    "title": "Sporting and Athletic Goods Manufacturing",
    "display_name": "(339920) Sporting and Athletic Goods Manufacturing"
  },
  {
    "id": 339930,
    "title": "Doll, Toy, and Game Manufacturing",
    "display_name": "(339930) Doll, Toy, and Game Manufacturing"
  },
  {
    "id": 339940,
    "title": "Office Supplies (except Paper) Manufacturing",
    "display_name": "(339940) Office Supplies (except Paper) Manufacturing"
  },
  {
    "id": 339950,
    "title": "Sign Manufacturing",
    "display_name": "(339950) Sign Manufacturing"
  },
  {
    "id": 339991,
    "title": "Gasket, Packing, and Sealing Device Manufacturing",
    "display_name": "(339991) Gasket, Packing, and Sealing Device Manufacturing"
  },
  {
    "id": 339992,
    "title": "Musical Instrument Manufacturing",
    "display_name": "(339992) Musical Instrument Manufacturing"
  },
  {
    "id": 339993,
    "title": "Fastener, Button, Needle, and Pin Manufacturing",
    "display_name": "(339993) Fastener, Button, Needle, and Pin Manufacturing"
  },
  {
    "id": 339994,
    "title": "Broom, Brush, and Mop Manufacturing",
    "display_name": "(339994) Broom, Brush, and Mop Manufacturing"
  },
  {
    "id": 339995,
    "title": "Burial Casket Manufacturing",
    "display_name": "(339995) Burial Casket Manufacturing"
  },
  {
    "id": 339999,
    "title": "All Other Miscellaneous Manufacturing",
    "display_name": "(339999) All Other Miscellaneous Manufacturing"
  },

   {
    "id": 423110,
    "title": "Automobile and Other Motor Vehicle Merchant Wholesalers",
    "display_name": "(423110) Automobile and Other Motor Vehicle Merchant Wholesalers"
  },
  {
    "id": 423120,
    "title": "Motor Vehicle Supplies and New Parts Merchant Wholesalers",
    "display_name": "(423120) Motor Vehicle Supplies and New Parts Merchant Wholesalers"
  },
  {
    "id": 423130,
    "title": "Tire and Tube Merchant Wholesalers",
    "display_name": "(423130) Tire and Tube Merchant Wholesalers"
  },
  {
    "id": 423140,
    "title": "Motor Vehicle Parts (Used) Merchant Wholesalers",
    "display_name": "(423140) Motor Vehicle Parts (Used) Merchant Wholesalers"
  },
  {
    "id": 423210,
    "title": "Furniture Merchant Wholesalers",
    "display_name": "(423210) Furniture Merchant Wholesalers"
  },
  {
    "id": 423220,
    "title": "Home Furnishing Merchant Wholesalers",
    "display_name": "(423220) Home Furnishing Merchant Wholesalers"
  },
  {
    "id": 423310,
    "title": "Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers",
    "display_name": "(423310) Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers"
  },
  {
    "id": 423320,
    "title": "Brick, Stone, and Related Construction Material Merchant Wholesalers",
    "display_name": "(423320) Brick, Stone, and Related Construction Material Merchant Wholesalers"
  },
  {
    "id": 423330,
    "title": "Roofing, Siding, and Insulation Material Merchant Wholesalers",
    "display_name": "(423330) Roofing, Siding, and Insulation Material Merchant Wholesalers"
  },
  {
    "id": 423390,
    "title": "Other Construction Material Merchant Wholesalers",
    "display_name": "(423390) Other Construction Material Merchant Wholesalers"
  },
  {
    "id": 423410,
    "title": "Photographic Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423410) Photographic Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423420,
    "title": "Office Equipment Merchant Wholesalers",
    "display_name": "(423420) Office Equipment Merchant Wholesalers"
  },
  {
    "id": 423430,
    "title": "Computer and Computer Peripheral Equipment and Software Merchant Wholesalers",
    "display_name": "(423430) Computer and Computer Peripheral Equipment and Software Merchant Wholesalers"
  },
  {
    "id": 423440,
    "title": "Other Commercial Equipment Merchant Wholesalers",
    "display_name": "(423440) Other Commercial Equipment Merchant Wholesalers"
  },
  {
    "id": 423450,
    "title": "Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423450) Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423460,
    "title": "Ophthalmic Goods Merchant Wholesalers",
    "display_name": "(423460) Ophthalmic Goods Merchant Wholesalers"
  },
  {
    "id": 423490,
    "title": "Other Professional Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423490) Other Professional Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423510,
    "title": "Metal Service Centers and Other Metal Merchant Wholesalers",
    "display_name": "(423510) Metal Service Centers and Other Metal Merchant Wholesalers"
  },
  {
    "id": 423520,
    "title": "Coal and Other Mineral and Ore Merchant Wholesalers",
    "display_name": "(423520) Coal and Other Mineral and Ore Merchant Wholesalers"
  },
  {
    "id": 423610,
    "title": "Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers",
    "display_name": "(423610) Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers"
  },
  {
    "id": 423620,
    "title": "Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers",
    "display_name": "(423620) Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers"
  },
  {
    "id": 423690,
    "title": "Other Electronic Parts and Equipment Merchant Wholesalers",
    "display_name": "(423690) Other Electronic Parts and Equipment Merchant Wholesalers"
  },
  {
    "id": 423710,
    "title": "Hardware Merchant Wholesalers",
    "display_name": "(423710) Hardware Merchant Wholesalers"
  },
  {
    "id": 423720,
    "title": "Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers",
    "display_name": "(423720) Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers"
  },
  {
    "id": 423730,
    "title": "Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423730) Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423740,
    "title": "Refrigeration Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423740) Refrigeration Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423810,
    "title": "Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers",
    "display_name": "(423810) Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers"
  },
  {
    "id": 423820,
    "title": "Farm and Garden Machinery and Equipment Merchant Wholesalers",
    "display_name": "(423820) Farm and Garden Machinery and Equipment Merchant Wholesalers"
  },
  {
    "id": 423830,
    "title": "Industrial Machinery and Equipment Merchant Wholesalers",
    "display_name": "(423830) Industrial Machinery and Equipment Merchant Wholesalers"
  },
  {
    "id": 423840,
    "title": "Industrial Supplies Merchant Wholesalers",
    "display_name": "(423840) Industrial Supplies Merchant Wholesalers"
  },
  {
    "id": 423850,
    "title": "Service Establishment Equipment and Supplies Merchant Wholesalers",
    "display_name": "(423850) Service Establishment Equipment and Supplies Merchant Wholesalers"
  },
  {
    "id": 423860,
    "title": "Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers",
    "display_name": "(423860) Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers"
  },
  {
    "id": 423910,
    "title": "Sporting and Recreational Goods and Supplies Merchant Wholesalers",
    "display_name": "(423910) Sporting and Recreational Goods and Supplies Merchant Wholesalers"
  },
  {
    "id": 423920,
    "title": "Toy and Hobby Goods and Supplies Merchant Wholesalers",
    "display_name": "(423920) Toy and Hobby Goods and Supplies Merchant Wholesalers"
  },
  {
    "id": 423930,
    "title": "Recyclable Material Merchant Wholesalers",
    "display_name": "(423930) Recyclable Material Merchant Wholesalers"
  },
  {
    "id": 423940,
    "title": "Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers",
    "display_name": "(423940) Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers"
  },
  {
    "id": 423990,
    "title": "Other Miscellaneous Durable Goods Merchant Wholesalers",
    "display_name": "(423990) Other Miscellaneous Durable Goods Merchant Wholesalers"
  },
  {
    "id": 424110,
    "title": "Printing and Writing Paper Merchant Wholesalers",
    "display_name": "(424110) Printing and Writing Paper Merchant Wholesalers"
  },
  {
    "id": 424120,
    "title": "Stationery and Office Supplies Merchant Wholesalers",
    "display_name": "(424120) Stationery and Office Supplies Merchant Wholesalers"
  },
  {
    "id": 424130,
    "title": "Industrial and Personal Service Paper Merchant Wholesalers",
    "display_name": "(424130) Industrial and Personal Service Paper Merchant Wholesalers"
  },
  {
    "id": 424210,
    "title": "Drugs and Druggists' Sundries Merchant Wholesalers",
    "display_name": "(424210) Drugs and Druggists' Sundries Merchant Wholesalers"
  },
  {
    "id": 424310,
    "title": "Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers",
    "display_name": "(424310) Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers"
  },
  {
    "id": 424340,
    "title": "Footwear Merchant Wholesalers",
    "display_name": "(424340) Footwear Merchant Wholesalers"
  },
  {
    "id": 424350,
    "title": "Clothing and Clothing Accessories Merchant Wholesalers",
    "display_name": "(424350) Clothing and Clothing Accessories Merchant Wholesalers"
  },
  {
    "id": 424410,
    "title": "General Line Grocery Merchant Wholesalers",
    "display_name": "(424410) General Line Grocery Merchant Wholesalers"
  },
  {
    "id": 424420,
    "title": "Packaged Frozen Food Merchant Wholesalers",
    "display_name": "(424420) Packaged Frozen Food Merchant Wholesalers"
  },
  {
    "id": 424430,
    "title": "Dairy Product (except Dried or Canned) Merchant Wholesalers",
    "display_name": "(424430) Dairy Product (except Dried or Canned) Merchant Wholesalers"
  },
  {
    "id": 424440,
    "title": "Poultry and Poultry Product Merchant Wholesalers",
    "display_name": "(424440) Poultry and Poultry Product Merchant Wholesalers"
  },
  {
    "id": 424450,
    "title": "Confectionery Merchant Wholesalers",
    "display_name": "(424450) Confectionery Merchant Wholesalers"
  },
  {
    "id": 424460,
    "title": "Fish and Seafood Merchant Wholesalers",
    "display_name": "(424460) Fish and Seafood Merchant Wholesalers"
  },
  {
    "id": 424470,
    "title": "Meat and Meat Product Merchant Wholesalers",
    "display_name": "(424470) Meat and Meat Product Merchant Wholesalers"
  },
  {
    "id": 424480,
    "title": "Fresh Fruit and Vegetable Merchant Wholesalers",
    "display_name": "(424480) Fresh Fruit and Vegetable Merchant Wholesalers"
  },
  {
    "id": 424490,
    "title": "Other Grocery and Related Products Merchant Wholesalers",
    "display_name": "(424490) Other Grocery and Related Products Merchant Wholesalers"
  },
  {
    "id": 424510,
    "title": "Grain and Field Bean Merchant Wholesalers",
    "display_name": "(424510) Grain and Field Bean Merchant Wholesalers"
  },
  {
    "id": 424520,
    "title": "Livestock Merchant Wholesalers",
    "display_name": "(424520) Livestock Merchant Wholesalers"
  },
  {
    "id": 424590,
    "title": "Other Farm Product Raw Material Merchant Wholesalers",
    "display_name": "(424590) Other Farm Product Raw Material Merchant Wholesalers"
  },
  {
    "id": 424610,
    "title": "Plastics Materials and Basic Forms and Shapes Merchant Wholesalers",
    "display_name": "(424610) Plastics Materials and Basic Forms and Shapes Merchant Wholesalers"
  },
  {
    "id": 424690,
    "title": "Other Chemical and Allied Products Merchant Wholesalers",
    "display_name": "(424690) Other Chemical and Allied Products Merchant Wholesalers"
  },
  {
    "id": 424710,
    "title": "Petroleum Bulk Stations and Terminals",
    "display_name": "(424710) Petroleum Bulk Stations and Terminals"
  },
  {
    "id": 424720,
    "title": "Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)",
    "display_name": "(424720) Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)"
  },
  {
    "id": 424810,
    "title": "Beer and Ale Merchant Wholesalers",
    "display_name": "(424810) Beer and Ale Merchant Wholesalers"
  },
  {
    "id": 424820,
    "title": "Wine and Distilled Alcoholic Beverage Merchant Wholesalers",
    "display_name": "(424820) Wine and Distilled Alcoholic Beverage Merchant Wholesalers"
  },
  {
    "id": 424910,
    "title": "Farm Supplies Merchant Wholesalers",
    "display_name": "(424910) Farm Supplies Merchant Wholesalers"
  },
  {
    "id": 424920,
    "title": "Book, Periodical, and Newspaper Merchant Wholesalers",
    "display_name": "(424920) Book, Periodical, and Newspaper Merchant Wholesalers"
  },
  {
    "id": 424930,
    "title": "Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers",
    "display_name": "(424930) Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers"
  },
  {
    "id": 424940,
    "title": "Tobacco Product and Electronic Cigarette Merchant Wholesalers",
    "display_name": "(424940) Tobacco Product and Electronic Cigarette Merchant Wholesalers"
  },
  {
    "id": 424950,
    "title": "Paint, Varnish, and Supplies Merchant Wholesalers",
    "display_name": "(424950) Paint, Varnish, and Supplies Merchant Wholesalers"
  },
  {
    "id": 424990,
    "title": "Other Miscellaneous Nondurable Goods Merchant Wholesalers",
    "display_name": "(424990) Other Miscellaneous Nondurable Goods Merchant Wholesalers"
  },
  {
    "id": 425120,
    "title": "Wholesale Trade Agents and Brokers",
    "display_name": "(425120) Wholesale Trade Agents and Brokers"
  },

  {
    "id": 441110,
    "title": "New Car Dealers",
    "display_name": "(441110) New Car Dealers"
  },
  {
    "id": 441120,
    "title": "Used Car Dealers",
    "display_name": "(441120) Used Car Dealers"
  },
  {
    "id": 441210,
    "title": "Recreational Vehicle Dealers",
    "display_name": "(441210) Recreational Vehicle Dealers"
  },
  {
    "id": 441222,
    "title": "Boat Dealers",
    "display_name": "(441222) Boat Dealers"
  },
  {
    "id": 441227,
    "title": "Motorcycle, ATV, and All Other Motor Vehicle Dealers",
    "display_name": "(441227) Motorcycle, ATV, and All Other Motor Vehicle Dealers"
  },
  {
    "id": 441330,
    "title": "Automotive Parts and Accessories Retailers",
    "display_name": "(441330) Automotive Parts and Accessories Retailers"
  },
  {
    "id": 441340,
    "title": "Tire Dealers",
    "display_name": "(441340) Tire Dealers"
  },
  {
    "id": 444110,
    "title": "Home Centers",
    "display_name": "(444110) Home Centers"
  },
  {
    "id": 444120,
    "title": "Paint and Wallpaper Retailers",
    "display_name": "(444120) Paint and Wallpaper Retailers"
  },
  {
    "id": 444140,
    "title": "Hardware Retailers",
    "display_name": "(444140) Hardware Retailers"
  },
  {
    "id": 444180,
    "title": "Other Building Material Dealers",
    "display_name": "(444180) Other Building Material Dealers"
  },
  {
    "id": 444230,
    "title": "Outdoor Power Equipment Retailers",
    "display_name": "(444230) Outdoor Power Equipment Retailers"
  },
  {
    "id": 444240,
    "title": "Nursery, Garden Center, and Farm Supply Retailers",
    "display_name": "(444240) Nursery, Garden Center, and Farm Supply Retailers"
  },
  {
    "id": 445110,
    "title": "Supermarkets and Other Grocery Retailers (except Convenience Retailers)",
    "display_name": "(445110) Supermarkets and Other Grocery Retailers (except Convenience Retailers)"
  },
  {
    "id": 445131,
    "title": "Convenience Retailers",
    "display_name": "(445131) Convenience Retailers"
  },
  {
    "id": 445132,
    "title": "Vending Machine Operators",
    "display_name": "(445132) Vending Machine Operators"
  },
  {
    "id": 445230,
    "title": "Fruit and Vegetable Retailers",
    "display_name": "(445230) Fruit and Vegetable Retailers"
  },
  {
    "id": 445240,
    "title": "Meat Retailers",
    "display_name": "(445240) Meat Retailers"
  },
  {
    "id": 445250,
    "title": "Fish and Seafood Retailers",
    "display_name": "(445250) Fish and Seafood Retailers"
  },
  {
    "id": 445291,
    "title": "Baked Goods Retailers",
    "display_name": "(445291) Baked Goods Retailers"
  },
  {
    "id": 445292,
    "title": "Confectionery and Nut Retailers",
    "display_name": "(445292) Confectionery and Nut Retailers"
  },
  {
    "id": 445298,
    "title": "All Other Specialty Food Retailers",
    "display_name": "(445298) All Other Specialty Food Retailers"
  },
  {
    "id": 445320,
    "title": "Beer, Wine, and Liquor Retailers",
    "display_name": "(445320) Beer, Wine, and Liquor Retailers"
  },
  {
    "id": 449110,
    "title": "Furniture Retailers",
    "display_name": "(449110) Furniture Retailers"
  },
  {
    "id": 449121,
    "title": "Floor Covering Retailers",
    "display_name": "(449121) Floor Covering Retailers"
  },
  {
    "id": 449122,
    "title": "Window Treatment Retailers",
    "display_name": "(449122) Window Treatment Retailers"
  },
  {
    "id": 449129,
    "title": "All Other Home Furnishings Retailers",
    "display_name": "(449129) All Other Home Furnishings Retailers"
  },
  {
    "id": 449210,
    "title": "Electronics and Appliance Retailers",
    "display_name": "(449210) Electronics and Appliance Retailers"
  },
  {
    "id": 455110,
    "title": "Department Stores",
    "display_name": "(455110) Department Stores"
  },
  {
    "id": 455211,
    "title": "Warehouse Clubs and Supercenters",
    "display_name": "(455211) Warehouse Clubs and Supercenters"
  },
  {
    "id": 455219,
    "title": "All Other General Merchandise Retailers",
    "display_name": "(455219) All Other General Merchandise Retailers"
  },
  {
    "id": 456110,
    "title": "Pharmacies and Drug Retailers",
    "display_name": "(456110) Pharmacies and Drug Retailers"
  },
  {
    "id": 456120,
    "title": "Cosmetics, Beauty Supplies, and Perfume Retailers",
    "display_name": "(456120) Cosmetics, Beauty Supplies, and Perfume Retailers"
  },
  {
    "id": 456130,
    "title": "Optical Goods Retailers",
    "display_name": "(456130) Optical Goods Retailers"
  },
  {
    "id": 456191,
    "title": "Food (Health) Supplement Retailers",
    "display_name": "(456191) Food (Health) Supplement Retailers"
  },
  {
    "id": 456199,
    "title": "All Other Health and Personal Care Retailers",
    "display_name": "(456199) All Other Health and Personal Care Retailers"
  },
  {
    "id": 457110,
    "title": "Gasoline Stations with Convenience Stores",
    "display_name": "(457110) Gasoline Stations with Convenience Stores"
  },
  {
    "id": 457120,
    "title": "Other Gasoline Stations",
    "display_name": "(457120) Other Gasoline Stations"
  },
  {
    "id": 457210,
    "title": "Fuel Dealers",
    "display_name": "(457210) Fuel Dealers"
  },
  {
    "id": 458110,
    "title": "Clothing and Clothing Accessories Retailers",
    "display_name": "(458110) Clothing and Clothing Accessories Retailers"
  },
  {
    "id": 458210,
    "title": "Shoe Retailers",
    "display_name": "(458210) Shoe Retailers"
  },
  {
    "id": 458310,
    "title": "Jewelry Retailers",
    "display_name": "(458310) Jewelry Retailers"
  },
  {
    "id": 458320,
    "title": "Luggage and Leather Goods Retailers",
    "display_name": "(458320) Luggage and Leather Goods Retailers"
  },
  {
    "id": 459110,
    "title": "Sporting Goods Retailers",
    "display_name": "(459110) Sporting Goods Retailers"
  },
  {
    "id": 459120,
    "title": "Hobby, Toy, and Game Retailers",
    "display_name": "(459120) Hobby, Toy, and Game Retailers"
  },
  {
    "id": 459130,
    "title": "Sewing, Needlework, and Piece Goods Retailers",
    "display_name": "(459130) Sewing, Needlework, and Piece Goods Retailers"
  },
  {
    "id": 459140,
    "title": "Musical Instrument and Supplies Retailers",
    "display_name": "(459140) Musical Instrument and Supplies Retailers"
  },
  {
    "id": 459210,
    "title": "Book Retailers and News Dealers",
    "display_name": "(459210) Book Retailers and News Dealers"
  },
  {
    "id": 459310,
    "title": "Florists",
    "display_name": "(459310) Florists"
  },
  {
    "id": 459410,
    "title": "Office Supplies and Stationery Retailers",
    "display_name": "(459410) Office Supplies and Stationery Retailers"
  },
  {
    "id": 459420,
    "title": "Gift, Novelty, and Souvenir Retailers",
    "display_name": "(459420) Gift, Novelty, and Souvenir Retailers"
  },
  {
    "id": 459510,
    "title": "Used Merchandise Retailers",
    "display_name": "(459510) Used Merchandise Retailers"
  },
  {
    "id": 459910,
    "title": "Pet and Pet Supplies Retailers",
    "display_name": "(459910) Pet and Pet Supplies Retailers"
  },
  {
    "id": 459920,
    "title": "Art Dealers",
    "display_name": "(459920) Art Dealers"
  },
  {
    "id": 459930,
    "title": "Manufactured (Mobile) Home Dealers",
    "display_name": "(459930) Manufactured (Mobile) Home Dealers"
  },
  {
    "id": 459991,
    "title": "Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers",
    "display_name": "(459991) Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers"
  },
  {
    "id": 459999,
    "title": "All Other Miscellaneous Retailers",
    "display_name": "(459999) All Other Miscellaneous Retailers"
  },
  {
    "id": 481111,
    "title": "Scheduled Passenger Air Transportation",
    "display_name": "(481111) Scheduled Passenger Air Transportation"
  },
  {
    "id": 481112,
    "title": "Scheduled Freight Air Transportation",
    "display_name": "(481112) Scheduled Freight Air Transportation"
  },
  {
    "id": 481211,
    "title": "Nonscheduled Chartered Passenger Air Transportation",
    "display_name": "(481211) Nonscheduled Chartered Passenger Air Transportation"
  },
  {
    "id": 481212,
    "title": "Nonscheduled Chartered Freight Air Transportation",
    "display_name": "(481212) Nonscheduled Chartered Freight Air Transportation"
  },
  {
    "id": 481219,
    "title": "Other Nonscheduled Air Transportation",
    "display_name": "(481219) Other Nonscheduled Air Transportation"
  },
  {
    "id": 482111,
    "title": "Line-Haul Railroads",
    "display_name": "(482111) Line-Haul Railroads"
  },
  {
    "id": 482112,
    "title": "Short Line Railroads",
    "display_name": "(482112) Short Line Railroads"
  },
  {
    "id": 483111,
    "title": "Deep Sea Freight Transportation",
    "display_name": "(483111) Deep Sea Freight Transportation"
  },
  {
    "id": 483112,
    "title": "Deep Sea Passenger Transportation",
    "display_name": "(483112) Deep Sea Passenger Transportation"
  },
  {
    "id": 483113,
    "title": "Coastal and Great Lakes Freight Transportation",
    "display_name": "(483113) Coastal and Great Lakes Freight Transportation"
  },
  {
    "id": 483114,
    "title": "Coastal and Great Lakes Passenger Transportation",
    "display_name": "(483114) Coastal and Great Lakes Passenger Transportation"
  },
  {
    "id": 483211,
    "title": "Inland Water Freight Transportation",
    "display_name": "(483211) Inland Water Freight Transportation"
  },
  {
    "id": 483212,
    "title": "Inland Water Passenger Transportation",
    "display_name": "(483212) Inland Water Passenger Transportation"
  },
  {
    "id": 484110,
    "title": "General Freight Trucking, Local",
    "display_name": "(484110) General Freight Trucking, Local"
  },
  {
    "id": 484121,
    "title": "General Freight Trucking, Long-Distance, Truckload",
    "display_name": "(484121) General Freight Trucking, Long-Distance, Truckload"
  },
  {
    "id": 484122,
    "title": "General Freight Trucking, Long-Distance, Less Than Truckload",
    "display_name": "(484122) General Freight Trucking, Long-Distance, Less Than Truckload"
  },
  {
    "id": 484210,
    "title": "Used Household and Office Goods Moving",
    "display_name": "(484210) Used Household and Office Goods Moving"
  },
  {
    "id": 484220,
    "title": "Specialized Freight (except Used Goods) Trucking, Local",
    "display_name": "(484220) Specialized Freight (except Used Goods) Trucking, Local"
  },
  {
    "id": 484230,
    "title": "Specialized Freight (except Used Goods) Trucking, Long-Distance",
    "display_name": "(484230) Specialized Freight (except Used Goods) Trucking, Long-Distance"
  },
  {
    "id": 485111,
    "title": "Mixed Mode Transit Systems",
    "display_name": "(485111) Mixed Mode Transit Systems"
  },
  {
    "id": 485112,
    "title": "Commuter Rail Systems",
    "display_name": "(485112) Commuter Rail Systems"
  },
  {
    "id": 485113,
    "title": "Bus and Other Motor Vehicle Transit Systems",
    "display_name": "(485113) Bus and Other Motor Vehicle Transit Systems"
  },
  {
    "id": 485119,
    "title": "Other Urban Transit Systems",
    "display_name": "(485119) Other Urban Transit Systems"
  },
  {
    "id": 485210,
    "title": "Interurban and Rural Bus Transportation",
    "display_name": "(485210) Interurban and Rural Bus Transportation"
  },
  {
    "id": 485310,
    "title": "Taxi and Ridesharing Services",
    "display_name": "(485310) Taxi and Ridesharing Services"
  },
  {
    "id": 485320,
    "title": "Limousine Service",
    "display_name": "(485320) Limousine Service"
  },
  {
    "id": 485410,
    "title": "School and Employee Bus Transportation",
    "display_name": "(485410) School and Employee Bus Transportation"
  },
  {
    "id": 485510,
    "title": "Charter Bus Industry",
    "display_name": "(485510) Charter Bus Industry"
  },
  {
    "id": 485991,
    "title": "Special Needs Transportation",
    "display_name": "(485991) Special Needs Transportation"
  },
  {
    "id": 485999,
    "title": "All Other Transit and Ground Passenger Transportation",
    "display_name": "(485999) All Other Transit and Ground Passenger Transportation"
  },
  {
    "id": 486110,
    "title": "Pipeline Transportation of Crude Oil",
    "display_name": "(486110) Pipeline Transportation of Crude Oil"
  },
  {
    "id": 486210,
    "title": "Pipeline Transportation of Natural Gas",
    "display_name": "(486210) Pipeline Transportation of Natural Gas"
  },
  {
    "id": 486910,
    "title": "Pipeline Transportation of Refined Petroleum Products",
    "display_name": "(486910) Pipeline Transportation of Refined Petroleum Products"
  },
  {
    "id": 487110,
    "title": "Scenic and Sightseeing Transportation, Land",
    "display_name": "(487110) Scenic and Sightseeing Transportation, Land"
  },
  {
    "id": 487210,
    "title": "Scenic and Sightseeing Transportation, Water",
    "display_name": "(487210) Scenic and Sightseeing Transportation, Water"
  },
  {
    "id": 487990,
    "title": "Scenic and Sightseeing Transportation, Other",
    "display_name": "(487990) Scenic and Sightseeing Transportation, Other"
  },
  {
    "id": 488111,
    "title": "Air Traffic Control",
    "display_name": "(488111) Air Traffic Control"
  },
  {
    "id": 488119,
    "title": "Other Airport Operations",
    "display_name": "(488119) Other Airport Operations"
  },
  {
    "id": 488190,
    "title": "Other Support Activities for Air Transportation",
    "display_name": "(488190) Other Support Activities for Air Transportation"
  },
  {
    "id": 488210,
    "title": "Support Activities for Rail Transportation",
    "display_name": "(488210) Support Activities for Rail Transportation"
  },
  {
    "id": 488310,
    "title": "Port and Harbor Operations",
    "display_name": "(488310) Port and Harbor Operations"
  },
  {
    "id": 488320,
    "title": "Marine Cargo Handling",
    "display_name": "(488320) Marine Cargo Handling"
  },
  {
    "id": 488330,
    "title": "Navigational Services to Shipping",
    "display_name": "(488330) Navigational Services to Shipping"
  },
  {
    "id": 488390,
    "title": "Other Support Activities for Water Transportation",
    "display_name": "(488390) Other Support Activities for Water Transportation"
  },
  {
    "id": 488410,
    "title": "Motor Vehicle Towing",
    "display_name": "(488410) Motor Vehicle Towing"
  },
  {
    "id": 488490,
    "title": "Other Support Activities for Road Transportation",
    "display_name": "(488490) Other Support Activities for Road Transportation"
  },
  {
    "id": 488510,
    "title": "Freight Transportation Arrangement",
    "display_name": "(488510) Freight Transportation Arrangement"
  },
  {
    "id": 488991,
    "title": "Packing and Crating",
    "display_name": "(488991) Packing and Crating"
  },
  {
    "id": 488999,
    "title": "All Other Support Activities for Transportation",
    "display_name": "(488999) All Other Support Activities for Transportation"
  },
  {
    "id": 491110,
    "title": "Postal Service",
    "display_name": "(491110) Postal Service"
  },
  {
    "id": 492110,
    "title": "Couriers and Express Delivery Services",
    "display_name": "(492110) Couriers and Express Delivery Services"
  },
  {
    "id": 492210,
    "title": "Local Messengers and Local Delivery",
    "display_name": "(492210) Local Messengers and Local Delivery"
  },
  {
    "id": 493110,
    "title": "General Warehousing and Storage",
    "display_name": "(493110) General Warehousing and Storage"
  },
  {
    "id": 493120,
    "title": "Refrigerated Warehousing and Storage",
    "display_name": "(493120) Refrigerated Warehousing and Storage"
  },
  {
    "id": 493130,
    "title": "Farm Product Warehousing and Storage",
    "display_name": "(493130) Farm Product Warehousing and Storage"
  },
  {
    "id": 493190,
    "title": "Other Warehousing and Storage",
    "display_name": "(493190) Other Warehousing and Storage"
  },
   {
    "id": 512110,
    "title": "Motion Picture and Video Production",
    "display_name": "(512110) Motion Picture and Video Production"
  },
  {
    "id": 512120,
    "title": "Motion Picture and Video Distribution",
    "display_name": "(512120) Motion Picture and Video Distribution"
  },
  {
    "id": 512131,
    "title": "Motion Picture Theaters (except Drive-Ins)",
    "display_name": "(512131) Motion Picture Theaters (except Drive-Ins)"
  },
  {
    "id": 512132,
    "title": "Drive-In Motion Picture Theaters",
    "display_name": "(512132) Drive-In Motion Picture Theaters"
  },
  {
    "id": 512191,
    "title": "Teleproduction and Other Postproduction Services",
    "display_name": "(512191) Teleproduction and Other Postproduction Services"
  },
  {
    "id": 512199,
    "title": "Other Motion Picture and Video Industries",
    "display_name": "(512199) Other Motion Picture and Video Industries"
  },
  {
    "id": 512230,
    "title": "Music Publishers",
    "display_name": "(512230) Music Publishers"
  },
  {
    "id": 512240,
    "title": "Sound Recording Studios",
    "display_name": "(512240) Sound Recording Studios"
  },
  {
    "id": 512250,
    "title": "Record Production and Distribution",
    "display_name": "(512250) Record Production and Distribution"
  },
  {
    "id": 512290,
    "title": "Other Sound Recording Industries",
    "display_name": "(512290) Other Sound Recording Industries"
  },
  {
    "id": 513110,
    "title": "Newspaper Publishers",
    "display_name": "(513110) Newspaper Publishers"
  },
  {
    "id": 513120,
    "title": "Periodical Publishers",
    "display_name": "(513120) Periodical Publishers"
  },
  {
    "id": 513130,
    "title": "Book Publishers",
    "display_name": "(513130) Book Publishers"
  },
  {
    "id": 513140,
    "title": "Directory and Mailing List Publishers",
    "display_name": "(513140) Directory and Mailing List Publishers"
  },
  {
    "id": 513191,
    "title": "Greeting Card Publishers",
    "display_name": "(513191) Greeting Card Publishers"
  },
  {
    "id": 513199,
    "title": "All Other Publishers",
    "display_name": "(513199) All Other Publishers"
  },
  {
    "id": 513210,
    "title": "Software Publishers",
    "display_name": "(513210) Software Publishers"
  },
  {
    "id": 516110,
    "title": "Radio Broadcasting Stations",
    "display_name": "(516110) Radio Broadcasting Stations"
  },
  {
    "id": 516120,
    "title": "Television Broadcasting Stations",
    "display_name": "(516120) Television Broadcasting Stations"
  },
  {
    "id": 516210,
    "title": "Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers",
    "display_name": "(516210) Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers"
  },
  {
    "id": 517111,
    "title": "Wired Telecommunications Carriers",
    "display_name": "(517111) Wired Telecommunications Carriers"
  },
  {
    "id": 517112,
    "title": "Wireless Telecommunications Carriers (except Satellite)",
    "display_name": "(517112) Wireless Telecommunications Carriers (except Satellite)"
  },
  {
    "id": 517121,
    "title": "Telecommunications Resellers",
    "display_name": "(517121) Telecommunications Resellers"
  },
  {
    "id": 517122,
    "title": "Agents for Wireless Telecommunications Services",
    "display_name": "(517122) Agents for Wireless Telecommunications Services"
  },
  {
    "id": 517410,
    "title": "Satellite Telecommunications",
    "display_name": "(517410) Satellite Telecommunications"
  },
  {
    "id": 517810,
    "title": "All Other Telecommunications",
    "display_name": "(517810) All Other Telecommunications"
  },
  {
    "id": 518210,
    "title": "Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services",
    "display_name": "(518210) Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services"
  },
  {
    "id": 519210,
    "title": "Libraries and Archives",
    "display_name": "(519210) Libraries and Archives"
  },
  {
    "id": 519290,
    "title": "Web Search Portals and All Other Information Services",
    "display_name": "(519290) Web Search Portals and All Other Information Services"
  },
   {
    "id": 521110,
    "title": "Monetary Authorities-Central Bank",
    "display_name": "(521110) Monetary Authorities-Central Bank"
  },
  {
    "id": 522110,
    "title": "Commercial Banking",
    "display_name": "(522110) Commercial Banking"
  },
  {
    "id": 522130,
    "title": "Credit Unions",
    "display_name": "(522130) Credit Unions"
  },
  {
    "id": 522180,
    "title": "Savings Institutions and Other Depository Credit Intermediation",
    "display_name": "(522180) Savings Institutions and Other Depository Credit Intermediation"
  },
  {
    "id": 522210,
    "title": "Credit Card Issuing",
    "display_name": "(522210) Credit Card Issuing"
  },
  {
    "id": 522220,
    "title": "Sales Financing",
    "display_name": "(522220) Sales Financing"
  },
  {
    "id": 522291,
    "title": "Consumer Lending",
    "display_name": "(522291) Consumer Lending"
  },
  {
    "id": 522292,
    "title": "Real Estate Credit",
    "display_name": "(522292) Real Estate Credit"
  },
  {
    "id": 522299,
    "title": "International, Secondary Market, and All Other Nondepository Credit Intermediation",
    "display_name": "(522299) International, Secondary Market, and All Other Nondepository Credit Intermediation"
  },
  {
    "id": 522310,
    "title": "Mortgage and Nonmortgage Loan Brokers",
    "display_name": "(522310) Mortgage and Nonmortgage Loan Brokers"
  },
  {
    "id": 522320,
    "title": "Financial Transactions Processing, Reserve, and Clearinghouse Activities",
    "display_name": "(522320) Financial Transactions Processing, Reserve, and Clearinghouse Activities"
  },
  {
    "id": 522390,
    "title": "Other Activities Related to Credit Intermediation",
    "display_name": "(522390) Other Activities Related to Credit Intermediation"
  },
  {
    "id": 523150,
    "title": "Investment Banking and Securities Intermediation",
    "display_name": "(523150) Investment Banking and Securities Intermediation"
  },
  {
    "id": 523160,
    "title": "Commodity Contracts Intermediation",
    "display_name": "(523160) Commodity Contracts Intermediation"
  },
  {
    "id": 523210,
    "title": "Securities and Commodity Exchanges",
    "display_name": "(523210) Securities and Commodity Exchanges"
  },
  {
    "id": 523910,
    "title": "Miscellaneous Intermediation",
    "display_name": "(523910) Miscellaneous Intermediation"
  },
  {
    "id": 523940,
    "title": "Portfolio Management and Investment Advice",
    "display_name": "(523940) Portfolio Management and Investment Advice"
  },
  {
    "id": 523991,
    "title": "Trust, Fiduciary, and Custody Activities",
    "display_name": "(523991) Trust, Fiduciary, and Custody Activities"
  },
  {
    "id": 523999,
    "title": "Miscellaneous Financial Investment Activities",
    "display_name": "(523999) Miscellaneous Financial Investment Activities"
  },
  {
    "id": 524113,
    "title": "Direct Life Insurance Carriers",
    "display_name": "(524113) Direct Life Insurance Carriers"
  },
  {
    "id": 524114,
    "title": "Direct Health and Medical Insurance Carriers",
    "display_name": "(524114) Direct Health and Medical Insurance Carriers"
  },
  {
    "id": 524126,
    "title": "Direct Property and Casualty Insurance Carriers",
    "display_name": "(524126) Direct Property and Casualty Insurance Carriers"
  },
  {
    "id": 524127,
    "title": "Direct Title Insurance Carriers",
    "display_name": "(524127) Direct Title Insurance Carriers"
  },
  {
    "id": 524128,
    "title": "Other Direct Insurance (except Life, Health, and Medical) Carriers",
    "display_name": "(524128) Other Direct Insurance (except Life, Health, and Medical) Carriers"
  },
  {
    "id": 524130,
    "title": "Reinsurance Carriers",
    "display_name": "(524130) Reinsurance Carriers"
  },
  {
    "id": 524210,
    "title": "Insurance Agencies and Brokerages",
    "display_name": "(524210) Insurance Agencies and Brokerages"
  },
  {
    "id": 524291,
    "title": "Claims Adjusting",
    "display_name": "(524291) Claims Adjusting"
  },
  {
    "id": 524292,
    "title": "Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds",
    "display_name": "(524292) Pharmacy Benefit Management and Other Third Party Administration of Insurance and Pension Funds"
  },
  {
    "id": 524298,
    "title": "All Other Insurance Related Activities",
    "display_name": "(524298) All Other Insurance Related Activities"
  },
  {
    "id": 525110,
    "title": "Pension Funds",
    "display_name": "(525110) Pension Funds"
  },
  {
    "id": 525120,
    "title": "Health and Welfare Funds",
    "display_name": "(525120) Health and Welfare Funds"
  },
  {
    "id": 525190,
    "title": "Other Insurance Funds",
    "display_name": "(525190) Other Insurance Funds"
  },
  {
    "id": 525910,
    "title": "Open-End Investment Funds",
    "display_name": "(525910) Open-End Investment Funds"
  },
  {
    "id": 525920,
    "title": "Trusts, Estates, and Agency Accounts",
    "display_name": "(525920) Trusts, Estates, and Agency Accounts"
  },
  {
    "id": 525990,
    "title": "Other Financial Vehicles",
    "display_name": "(525990) Other Financial Vehicles"
  },
  {
    "id": 531110,
    "title": "Lessors of Residential Buildings and Dwellings",
    "display_name": "(531110) Lessors of Residential Buildings and Dwellings"
  },
  {
    "id": 531120,
    "title": "Lessors of Nonresidential Buildings (except Miniwarehouses)",
    "display_name": "(531120) Lessors of Nonresidential Buildings (except Miniwarehouses)"
  },
  {
    "id": 531130,
    "title": "Lessors of Miniwarehouses and Self-Storage Units",
    "display_name": "(531130) Lessors of Miniwarehouses and Self-Storage Units"
  },
  {
    "id": 531190,
    "title": "Lessors of Other Real Estate Property",
    "display_name": "(531190) Lessors of Other Real Estate Property"
  },
  {
    "id": 531210,
    "title": "Offices of Real Estate Agents and Brokers",
    "display_name": "(531210) Offices of Real Estate Agents and Brokers"
  },
  {
    "id": 531311,
    "title": "Residential Property Managers",
    "display_name": "(531311) Residential Property Managers"
  },
  {
    "id": 531312,
    "title": "Nonresidential Property Managers",
    "display_name": "(531312) Nonresidential Property Managers"
  },
  {
    "id": 531320,
    "title": "Offices of Real Estate Appraisers",
    "display_name": "(531320) Offices of Real Estate Appraisers"
  },
  {
    "id": 531390,
    "title": "Other Activities Related to Real Estate",
    "display_name": "(531390) Other Activities Related to Real Estate"
  },
  {
    "id": 532111,
    "title": "Passenger Car Rental",
    "display_name": "(532111) Passenger Car Rental"
  },
  {
    "id": 532112,
    "title": "Passenger Car Leasing",
    "display_name": "(532112) Passenger Car Leasing"
  },
  {
    "id": 532120,
    "title": "Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing",
    "display_name": "(532120) Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing"
  },
  {
    "id": 532210,
    "title": "Consumer Electronics and Appliances Rental",
    "display_name": "(532210) Consumer Electronics and Appliances Rental"
  },
  {
    "id": 532281,
    "title": "Formal Wear and Costume Rental",
    "display_name": "(532281) Formal Wear and Costume Rental"
  },
  {
    "id": 532282,
    "title": "Video Tape and Disc Rental",
    "display_name": "(532282) Video Tape and Disc Rental"
  },
  {
    "id": 532283,
    "title": "Home Health Equipment Rental",
    "display_name": "(532283) Home Health Equipment Rental"
  },
  {
    "id": 532284,
    "title": "Recreational Goods Rental",
    "display_name": "(532284) Recreational Goods Rental"
  },
  {
    "id": 532289,
    "title": "All Other Consumer Goods Rental",
    "display_name": "(532289) All Other Consumer Goods Rental"
  },
  {
    "id": 532310,
    "title": "General Rental Centers",
    "display_name": "(532310) General Rental Centers"
  },
  {
    "id": 532411,
    "title": "Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing",
    "display_name": "(532411) Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing"
  },
  {
    "id": 532412,
    "title": "Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing",
    "display_name": "(532412) Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing"
  },
  {
    "id": 532420,
    "title": "Office Machinery and Equipment Rental and Leasing",
    "display_name": "(532420) Office Machinery and Equipment Rental and Leasing"
  },
  {
    "id": 532490,
    "title": "Other Commercial and Industrial Machinery and Equipment Rental and Leasing",
    "display_name": "(532490) Other Commercial and Industrial Machinery and Equipment Rental and Leasing"
  },
  {
    "id": 533110,
    "title": "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
    "display_name": "(533110) Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)"
  },
  {
    "id": 541110,
    "title": "Offices of Lawyers",
    "display_name": "(541110) Offices of Lawyers"
  },
  {
    "id": 541120,
    "title": "Offices of Notaries",
    "display_name": "(541120) Offices of Notaries"
  },
  {
    "id": 541191,
    "title": "Title Abstract and Settlement Offices",
    "display_name": "(541191) Title Abstract and Settlement Offices"
  },
  {
    "id": 541199,
    "title": "All Other Legal Services",
    "display_name": "(541199) All Other Legal Services"
  },
  {
    "id": 541211,
    "title": "Offices of Certified Public Accountants",
    "display_name": "(541211) Offices of Certified Public Accountants"
  },
  {
    "id": 541213,
    "title": "Tax Preparation Services",
    "display_name": "(541213) Tax Preparation Services"
  },
  {
    "id": 541214,
    "title": "Payroll Services",
    "display_name": "(541214) Payroll Services"
  },
  {
    "id": 541219,
    "title": "Other Accounting Services",
    "display_name": "(541219) Other Accounting Services"
  },
  {
    "id": 541310,
    "title": "Architectural Services",
    "display_name": "(541310) Architectural Services"
  },
  {
    "id": 541320,
    "title": "Landscape Architectural Services",
    "display_name": "(541320) Landscape Architectural Services"
  },
  {
    "id": 541330,
    "title": "Engineering Services",
    "display_name": "(541330) Engineering Services"
  },
  {
    "id": 541340,
    "title": "Drafting Services",
    "display_name": "(541340) Drafting Services"
  },
  {
    "id": 541350,
    "title": "Building Inspection Services",
    "display_name": "(541350) Building Inspection Services"
  },
  {
    "id": 541360,
    "title": "Geophysical Surveying and Mapping Services",
    "display_name": "(541360) Geophysical Surveying and Mapping Services"
  },
  {
    "id": 541370,
    "title": "Surveying and Mapping (except Geophysical) Services",
    "display_name": "(541370) Surveying and Mapping (except Geophysical) Services"
  },
  {
    "id": 541380,
    "title": "Testing Laboratories and Services",
    "display_name": "(541380) Testing Laboratories and Services"
  },
   {
    "id": 541410,
    "title": "Interior Design Services",
    "display_name": "(541410) Interior Design Services"
  },
  {
    "id": 541420,
    "title": "Industrial Design Services",
    "display_name": "(541420) Industrial Design Services"
  },
  {
    "id": 541430,
    "title": "Graphic Design Services",
    "display_name": "(541430) Graphic Design Services"
  },
  {
    "id": 541490,
    "title": "Other Specialized Design Services",
    "display_name": "(541490) Other Specialized Design Services"
  },
  {
    "id": 541511,
    "title": "Custom Computer Programming Services",
    "display_name": "(541511) Custom Computer Programming Services"
  },
  {
    "id": 541512,
    "title": "Computer Systems Design Services",
    "display_name": "(541512) Computer Systems Design Services"
  },
  {
    "id": 541513,
    "title": "Computer Facilities Management Services",
    "display_name": "(541513) Computer Facilities Management Services"
  },
  {
    "id": 541519,
    "title": "Other Computer Related Services",
    "display_name": "(541519) Other Computer Related Services"
  },
  {
    "id": 541611,
    "title": "Administrative Management and General Management Consulting Services",
    "display_name": "(541611) Administrative Management and General Management Consulting Services"
  },
  {
    "id": 541612,
    "title": "Human Resources Consulting Services",
    "display_name": "(541612) Human Resources Consulting Services"
  },
  {
    "id": 541613,
    "title": "Marketing Consulting Services",
    "display_name": "(541613) Marketing Consulting Services"
  },
  {
    "id": 541614,
    "title": "Process, Physical Distribution, and Logistics Consulting Services",
    "display_name": "(541614) Process, Physical Distribution, and Logistics Consulting Services"
  },
  {
    "id": 541618,
    "title": "Other Management Consulting Services",
    "display_name": "(541618) Other Management Consulting Services"
  },
  {
    "id": 541620,
    "title": "Environmental Consulting Services",
    "display_name": "(541620) Environmental Consulting Services"
  },
  {
    "id": 541690,
    "title": "Other Scientific and Technical Consulting Services",
    "display_name": "(541690) Other Scientific and Technical Consulting Services"
  },
  {
    "id": 541713,
    "title": "Research and Development in Nanotechnology",
    "display_name": "(541713) Research and Development in Nanotechnology"
  },
  {
    "id": 541714,
    "title": "Research and Development in Biotechnology (except Nanobiotechnology)",
    "display_name": "(541714) Research and Development in Biotechnology (except Nanobiotechnology)"
  },
  {
    "id": 541715,
    "title": "Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)",
    "display_name": "(541715) Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)"
  },
  {
    "id": 541720,
    "title": "Research and Development in the Social Sciences and Humanities",
    "display_name": "(541720) Research and Development in the Social Sciences and Humanities"
  },
  {
    "id": 541810,
    "title": "Advertising Agencies",
    "display_name": "(541810) Advertising Agencies"
  },
  {
    "id": 541820,
    "title": "Public Relations Agencies",
    "display_name": "(541820) Public Relations Agencies"
  },
  {
    "id": 541830,
    "title": "Media Buying Agencies",
    "display_name": "(541830) Media Buying Agencies"
  },
  {
    "id": 541840,
    "title": "Media Representatives",
    "display_name": "(541840) Media Representatives"
  },
  {
    "id": 541850,
    "title": "Indoor and Outdoor Display Advertising",
    "display_name": "(541850) Indoor and Outdoor Display Advertising"
  },
  {
    "id": 541860,
    "title": "Direct Mail Advertising",
    "display_name": "(541860) Direct Mail Advertising"
  },
  {
    "id": 541870,
    "title": "Advertising Material Distribution Services",
    "display_name": "(541870) Advertising Material Distribution Services"
  },
  {
    "id": 541890,
    "title": "Other Services Related to Advertising",
    "display_name": "(541890) Other Services Related to Advertising"
  },
  {
    "id": 541910,
    "title": "Marketing Research and Public Opinion Polling",
    "display_name": "(541910) Marketing Research and Public Opinion Polling"
  },
  {
    "id": 541921,
    "title": "Photography Studios, Portrait",
    "display_name": "(541921) Photography Studios, Portrait"
  },
  {
    "id": 541922,
    "title": "Commercial Photography",
    "display_name": "(541922) Commercial Photography"
  },
  {
    "id": 541930,
    "title": "Translation and Interpretation Services",
    "display_name": "(541930) Translation and Interpretation Services"
  },
  {
    "id": 541940,
    "title": "Veterinary Services",
    "display_name": "(541940) Veterinary Services"
  },
  {
    "id": 541990,
    "title": "All Other Professional, Scientific, and Technical Services",
    "display_name": "(541990) All Other Professional, Scientific, and Technical Services"
  },
  {
    "id": 551111,
    "title": "Offices of Bank Holding Companies",
    "display_name": "(551111) Offices of Bank Holding Companies"
  },
  {
    "id": 551112,
    "title": "Offices of Other Holding Companies",
    "display_name": "(551112) Offices of Other Holding Companies"
  },
  {
    "id": 551114,
    "title": "Corporate, Subsidiary, and Regional Managing Offices",
    "display_name": "(551114) Corporate, Subsidiary, and Regional Managing Offices"
  },
  {
    "id": 561110,
    "title": "Office Administrative Services",
    "display_name": "(561110) Office Administrative Services"
  },
  {
    "id": 561210,
    "title": "Facilities Support Services",
    "display_name": "(561210) Facilities Support Services"
  },
  {
    "id": 561311,
    "title": "Employment Placement Agencies",
    "display_name": "(561311) Employment Placement Agencies"
  },
  {
    "id": 561312,
    "title": "Executive Search Services",
    "display_name": "(561312) Executive Search Services"
  },
  {
    "id": 561320,
    "title": "Temporary Help Services",
    "display_name": "(561320) Temporary Help Services"
  },
  {
    "id": 561330,
    "title": "Professional Employer Organizations",
    "display_name": "(561330) Professional Employer Organizations"
  },
  {
    "id": 561410,
    "title": "Document Preparation Services",
    "display_name": "(561410) Document Preparation Services"
  },
  {
    "id": 561421,
    "title": "Telephone Answering Services",
    "display_name": "(561421) Telephone Answering Services"
  },
  {
    "id": 561422,
    "title": "Telemarketing Bureaus and Other Contact Centers",
    "display_name": "(561422) Telemarketing Bureaus and Other Contact Centers"
  },
  {
    "id": 561431,
    "title": "Private Mail Centers",
    "display_name": "(561431) Private Mail Centers"
  },
  {
    "id": 561439,
    "title": "Other Business Service Centers (including Copy Shops)",
    "display_name": "(561439) Other Business Service Centers (including Copy Shops)"
  },
  {
    "id": 561440,
    "title": "Collection Agencies",
    "display_name": "(561440) Collection Agencies"
  },
  {
    "id": 561450,
    "title": "Credit Bureaus",
    "display_name": "(561450) Credit Bureaus"
  },
  {
    "id": 561491,
    "title": "Repossession Services",
    "display_name": "(561491) Repossession Services"
  },
  {
    "id": 561492,
    "title": "Court Reporting and Stenotype Services",
    "display_name": "(561492) Court Reporting and Stenotype Services"
  },
  {
    "id": 561499,
    "title": "All Other Business Support Services",
    "display_name": "(561499) All Other Business Support Services"
  },
  {
    "id": 561510,
    "title": "Travel Agencies",
    "display_name": "(561510) Travel Agencies"
  },
  {
    "id": 561520,
    "title": "Tour Operators",
    "display_name": "(561520) Tour Operators"
  },
  {
    "id": 561591,
    "title": "Convention and Visitors Bureaus",
    "display_name": "(561591) Convention and Visitors Bureaus"
  },
  {
    "id": 561599,
    "title": "All Other Travel Arrangement and Reservation Services",
    "display_name": "(561599) All Other Travel Arrangement and Reservation Services"
  },
  {
    "id": 561611,
    "title": "Investigation and Personal Background Check Services",
    "display_name": "(561611) Investigation and Personal Background Check Services"
  },
  {
    "id": 561612,
    "title": "Security Guards and Patrol Services",
    "display_name": "(561612) Security Guards and Patrol Services"
  },
  {
    "id": 561613,
    "title": "Armored Car Services",
    "display_name": "(561613) Armored Car Services"
  },
  {
    "id": 561621,
    "title": "Security Systems Services (except Locksmiths)",
    "display_name": "(561621) Security Systems Services (except Locksmiths)"
  },
  {
    "id": 561622,
    "title": "Locksmiths",
    "display_name": "(561622) Locksmiths"
  },
  {
    "id": 561710,
    "title": "Exterminating and Pest Control Services",
    "display_name": "(561710) Exterminating and Pest Control Services"
  },
  {
    "id": 561720,
    "title": "Janitorial Services",
    "display_name": "(561720) Janitorial Services"
  },
  {
    "id": 561730,
    "title": "Landscaping Services",
    "display_name": "(561730) Landscaping Services"
  },
  {
    "id": 561740,
    "title": "Carpet and Upholstery Cleaning Services",
    "display_name": "(561740) Carpet and Upholstery Cleaning Services"
  },
  {
    "id": 561790,
    "title": "Other Services to Buildings and Dwellings",
    "display_name": "(561790) Other Services to Buildings and Dwellings"
  },
  {
    "id": 561910,
    "title": "Packaging and Labeling Services",
    "display_name": "(561910) Packaging and Labeling Services"
  },
  {
    "id": 561920,
    "title": "Convention and Trade Show Organizers",
    "display_name": "(561920) Convention and Trade Show Organizers"
  },
  {
    "id": 561990,
    "title": "All Other Support Services",
    "display_name": "(561990) All Other Support Services"
  },
  {
    "id": 562111,
    "title": "Solid Waste Collection",
    "display_name": "(562111) Solid Waste Collection"
  },
  {
    "id": 562112,
    "title": "Hazardous Waste Collection",
    "display_name": "(562112) Hazardous Waste Collection"
  },
  {
    "id": 562119,
    "title": "Other Waste Collection",
    "display_name": "(562119) Other Waste Collection"
  },
  {
    "id": 562211,
    "title": "Hazardous Waste Treatment and Disposal",
    "display_name": "(562211) Hazardous Waste Treatment and Disposal"
  },
  {
    "id": 562212,
    "title": "Solid Waste Landfill",
    "display_name": "(562212) Solid Waste Landfill"
  },
  {
    "id": 562213,
    "title": "Solid Waste Combustors and Incinerators",
    "display_name": "(562213) Solid Waste Combustors and Incinerators"
  },
  {
    "id": 562219,
    "title": "Other Nonhazardous Waste Treatment and Disposal",
    "display_name": "(562219) Other Nonhazardous Waste Treatment and Disposal"
  },
  {
    "id": 562910,
    "title": "Remediation Services",
    "display_name": "(562910) Remediation Services"
  },
  {
    "id": 562920,
    "title": "Materials Recovery Facilities",
    "display_name": "(562920) Materials Recovery Facilities"
  },
  {
    "id": 562991,
    "title": "Septic Tank and Related Services",
    "display_name": "(562991) Septic Tank and Related Services"
  },
  {
    "id": 562998,
    "title": "All Other Miscellaneous Waste Management Services",
    "display_name": "(562998) All Other Miscellaneous Waste Management Services"
  },
  {
    "id": 611110,
    "title": "Elementary and Secondary Schools",
    "display_name": "(611110) Elementary and Secondary Schools"
  },
  {
    "id": 611210,
    "title": "Junior Colleges",
    "display_name": "(611210) Junior Colleges"
  },
  {
    "id": 611310,
    "title": "Colleges, Universities, and Professional Schools",
    "display_name": "(611310) Colleges, Universities, and Professional Schools"
  },
  {
    "id": 611410,
    "title": "Business and Secretarial Schools",
    "display_name": "(611410) Business and Secretarial Schools"
  },
  {
    "id": 611420,
    "title": "Computer Training",
    "display_name": "(611420) Computer Training"
  },
  {
    "id": 611430,
    "title": "Professional and Management Development Training",
    "display_name": "(611430) Professional and Management Development Training"
  },
  {
    "id": 611511,
    "title": "Cosmetology and Barber Schools",
    "display_name": "(611511) Cosmetology and Barber Schools"
  },
  {
    "id": 611512,
    "title": "Flight Training",
    "display_name": "(611512) Flight Training"
  },
  {
    "id": 611513,
    "title": "Apprenticeship Training",
    "display_name": "(611513) Apprenticeship Training"
  },
  {
    "id": 611519,
    "title": "Other Technical and Trade Schools",
    "display_name": "(611519) Other Technical and Trade Schools"
  },
  {
    "id": 611610,
    "title": "Fine Arts Schools",
    "display_name": "(611610) Fine Arts Schools"
  },
  {
    "id": 611620,
    "title": "Sports and Recreation Instruction",
    "display_name": "(611620) Sports and Recreation Instruction"
  },
  {
    "id": 611630,
    "title": "Language Schools",
    "display_name": "(611630) Language Schools"
  },
  {
    "id": 611691,
    "title": "Exam Preparation and Tutoring",
    "display_name": "(611691) Exam Preparation and Tutoring"
  },
  {
    "id": 611692,
    "title": "Automobile Driving Schools",
    "display_name": "(611692) Automobile Driving Schools"
  },
  {
    "id": 611699,
    "title": "All Other Miscellaneous Schools and Instruction",
    "display_name": "(611699) All Other Miscellaneous Schools and Instruction"
  },
  {
    "id": 611710,
    "title": "Educational Support Services",
    "display_name": "(611710) Educational Support Services"
  },
  {
    "id": 621111,
    "title": "Offices of Physicians (except Mental Health Specialists)",
    "display_name": "(621111) Offices of Physicians (except Mental Health Specialists)"
  },
  {
    "id": 621112,
    "title": "Offices of Physicians, Mental Health Specialists",
    "display_name": "(621112) Offices of Physicians, Mental Health Specialists"
  },
  {
    "id": 621210,
    "title": "Offices of Dentists",
    "display_name": "(621210) Offices of Dentists"
  },
  {
    "id": 621310,
    "title": "Offices of Chiropractors",
    "display_name": "(621310) Offices of Chiropractors"
  },
  {
    "id": 621320,
    "title": "Offices of Optometrists",
    "display_name": "(621320) Offices of Optometrists"
  },
  {
    "id": 621330,
    "title": "Offices of Mental Health Practitioners (except Physicians)",
    "display_name": "(621330) Offices of Mental Health Practitioners (except Physicians)"
  },
  {
    "id": 621340,
    "title": "Offices of Physical, Occupational and Speech Therapists, and Audiologists",
    "display_name": "(621340) Offices of Physical, Occupational and Speech Therapists, and Audiologists"
  },
  {
    "id": 621391,
    "title": "Offices of Podiatrists",
    "display_name": "(621391) Offices of Podiatrists"
  },
  {
    "id": 621399,
    "title": "Offices of All Other Miscellaneous Health Practitioners",
    "display_name": "(621399) Offices of All Other Miscellaneous Health Practitioners"
  },
  {
    "id": 621410,
    "title": "Family Planning Centers",
    "display_name": "(621410) Family Planning Centers"
  },
  {
    "id": 621420,
    "title": "Outpatient Mental Health and Substance Abuse Centers",
    "display_name": "(621420) Outpatient Mental Health and Substance Abuse Centers"
  },
  {
    "id": 621491,
    "title": "HMO Medical Centers",
    "display_name": "(621491) HMO Medical Centers"
  },
  {
    "id": 621492,
    "title": "Kidney Dialysis Centers",
    "display_name": "(621492) Kidney Dialysis Centers"
  },
  {
    "id": 621493,
    "title": "Freestanding Ambulatory Surgical and Emergency Centers",
    "display_name": "(621493) Freestanding Ambulatory Surgical and Emergency Centers"
  },
  {
    "id": 621498,
    "title": "All Other Outpatient Care Centers",
    "display_name": "(621498) All Other Outpatient Care Centers"
  },
  {
    "id": 621511,
    "title": "Medical Laboratories",
    "display_name": "(621511) Medical Laboratories"
  },
  {
    "id": 621512,
    "title": "Diagnostic Imaging Centers",
    "display_name": "(621512) Diagnostic Imaging Centers"
  },
  {
    "id": 621610,
    "title": "Home Health Care Services",
    "display_name": "(621610) Home Health Care Services"
  },
  {
    "id": 621910,
    "title": "Ambulance Services",
    "display_name": "(621910) Ambulance Services"
  },
  {
    "id": 621991,
    "title": "Blood and Organ Banks",
    "display_name": "(621991) Blood and Organ Banks"
  },
  {
    "id": 621999,
    "title": "All Other Miscellaneous Ambulatory Health Care Services",
    "display_name": "(621999) All Other Miscellaneous Ambulatory Health Care Services"
  },
  {
    "id": 622110,
    "title": "General Medical and Surgical Hospitals",
    "display_name": "(622110) General Medical and Surgical Hospitals"
  },
  {
    "id": 622210,
    "title": "Psychiatric and Substance Abuse Hospitals",
    "display_name": "(622210) Psychiatric and Substance Abuse Hospitals"
  },
  {
    "id": 622310,
    "title": "Specialty (except Psychiatric and Substance Abuse) Hospitals",
    "display_name": "(622310) Specialty (except Psychiatric and Substance Abuse) Hospitals"
  },
  {
    "id": 623110,
    "title": "Nursing Care Facilities (Skilled Nursing Facilities)",
    "display_name": "(623110) Nursing Care Facilities (Skilled Nursing Facilities)"
  },
  {
    "id": 623210,
    "title": "Residential Intellectual and Developmental Disability Facilities",
    "display_name": "(623210) Residential Intellectual and Developmental Disability Facilities"
  },
  {
    "id": 623220,
    "title": "Residential Mental Health and Substance Abuse Facilities",
    "display_name": "(623220) Residential Mental Health and Substance Abuse Facilities"
  },
  {
    "id": 623311,
    "title": "Continuing Care Retirement Communities",
    "display_name": "(623311) Continuing Care Retirement Communities"
  },
  {
    "id": 623312,
    "title": "Assisted Living Facilities for the Elderly",
    "display_name": "(623312) Assisted Living Facilities for the Elderly"
  },
  {
    "id": 623990,
    "title": "Other Residential Care Facilities",
    "display_name": "(623990) Other Residential Care Facilities"
  },
  {
    "id": 624110,
    "title": "Child and Youth Services",
    "display_name": "(624110) Child and Youth Services"
  },
  {
    "id": 624120,
    "title": "Services for the Elderly and Persons with Disabilities",
    "display_name": "(624120) Services for the Elderly and Persons with Disabilities"
  },
  {
    "id": 624190,
    "title": "Other Individual and Family Services",
    "display_name": "(624190) Other Individual and Family Services"
  },
  {
    "id": 624210,
    "title": "Community Food Services",
    "display_name": "(624210) Community Food Services"
  },
  {
    "id": 624221,
    "title": "Temporary Shelters",
    "display_name": "(624221) Temporary Shelters"
  },
  {
    "id": 624229,
    "title": "Other Community Housing Services",
    "display_name": "(624229) Other Community Housing Services"
  },
  {
    "id": 624230,
    "title": "Emergency and Other Relief Services",
    "display_name": "(624230) Emergency and Other Relief Services"
  },
  {
    "id": 624310,
    "title": "Vocational Rehabilitation Services",
    "display_name": "(624310) Vocational Rehabilitation Services"
  },
  {
    "id": 624410,
    "title": "Child Care Services",
    "display_name": "(624410) Child Care Services"
  },
  {
    "id": 711110,
    "title": "Theater Companies and Dinner Theaters",
    "display_name": "(711110) Theater Companies and Dinner Theaters"
  },
  {
    "id": 711120,
    "title": "Dance Companies",
    "display_name": "(711120) Dance Companies"
  },
  {
    "id": 711130,
    "title": "Musical Groups and Artists",
    "display_name": "(711130) Musical Groups and Artists"
  },
  {
    "id": 711190,
    "title": "Other Performing Arts Companies",
    "display_name": "(711190) Other Performing Arts Companies"
  },
  {
    "id": 711211,
    "title": "Sports Teams and Clubs",
    "display_name": "(711211) Sports Teams and Clubs"
  },
  {
    "id": 711212,
    "title": "Racetracks",
    "display_name": "(711212) Racetracks"
  },
  {
    "id": 711219,
    "title": "Other Spectator Sports",
    "display_name": "(711219) Other Spectator Sports"
  },
  {
    "id": 711310,
    "title": "Promoters of Performing Arts, Sports, and Similar Events with Facilities",
    "display_name": "(711310) Promoters of Performing Arts, Sports, and Similar Events with Facilities"
  },
  {
    "id": 711320,
    "title": "Promoters of Performing Arts, Sports, and Similar Events without Facilities",
    "display_name": "(711320) Promoters of Performing Arts, Sports, and Similar Events without Facilities"
  },
  {
    "id": 711410,
    "title": "Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures",
    "display_name": "(711410) Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures"
  },
  {
    "id": 711510,
    "title": "Independent Artists, Writers, and Performers",
    "display_name": "(711510) Independent Artists, Writers, and Performers"
  },
  {
    "id": 712110,
    "title": "Museums",
    "display_name": "(712110) Museums"
  },
  {
    "id": 712120,
    "title": "Historical Sites",
    "display_name": "(712120) Historical Sites"
  },
  {
    "id": 712130,
    "title": "Zoos and Botanical Gardens",
    "display_name": "(712130) Zoos and Botanical Gardens"
  },
  {
    "id": 712190,
    "title": "Nature Parks and Other Similar Institutions",
    "display_name": "(712190) Nature Parks and Other Similar Institutions"
  },
  {
    "id": 713110,
    "title": "Amusement and Theme Parks",
    "display_name": "(713110) Amusement and Theme Parks"
  },
  {
    "id": 713120,
    "title": "Amusement Arcades",
    "display_name": "(713120) Amusement Arcades"
  },
  {
    "id": 713210,
    "title": "Casinos (except Casino Hotels)",
    "display_name": "(713210) Casinos (except Casino Hotels)"
  },
  {
    "id": 713290,
    "title": "Other Gambling Industries",
    "display_name": "(713290) Other Gambling Industries"
  },
  {
    "id": 713910,
    "title": "Golf Courses and Country Clubs",
    "display_name": "(713910) Golf Courses and Country Clubs"
  },
  {
    "id": 713920,
    "title": "Skiing Facilities",
    "display_name": "(713920) Skiing Facilities"
  },
  {
    "id": 713930,
    "title": "Marinas",
    "display_name": "(713930) Marinas"
  },
  {
    "id": 713940,
    "title": "Fitness and Recreational Sports Centers",
    "display_name": "(713940) Fitness and Recreational Sports Centers"
  },
  {
    "id": 713950,
    "title": "Bowling Centers",
    "display_name": "(713950) Bowling Centers"
  },
  {
    "id": 713990,
    "title": "All Other Amusement and Recreation Industries",
    "display_name": "(713990) All Other Amusement and Recreation Industries"
  },
  {
    "id": 721110,
    "title": "Hotels (except Casino Hotels) and Motels",
    "display_name": "(721110) Hotels (except Casino Hotels) and Motels"
  },
  {
    "id": 721120,
    "title": "Casino Hotels",
    "display_name": "(721120) Casino Hotels"
  },
  {
    "id": 721191,
    "title": "Bed-and-Breakfast Inns",
    "display_name": "(721191) Bed-and-Breakfast Inns"
  },
  {
    "id": 721199,
    "title": "All Other Traveler Accommodation",
    "display_name": "(721199) All Other Traveler Accommodation"
  },
   {
    "id": 721211,
    "title": "RV (Recreational Vehicle) Parks and Campgrounds",
    "display_name": "(721211) RV (Recreational Vehicle) Parks and Campgrounds"
  },
  {
    "id": 721214,
    "title": "Recreational and Vacation Camps (except Campgrounds)",
    "display_name": "(721214) Recreational and Vacation Camps (except Campgrounds)"
  },
  {
    "id": 721310,
    "title": "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
    "display_name": "(721310) Rooming and Boarding Houses, Dormitories, and Workers' Camps"
  },
  {
    "id": 722310,
    "title": "Food Service Contractors",
    "display_name": "(722310) Food Service Contractors"
  },
  {
    "id": 722320,
    "title": "Caterers",
    "display_name": "(722320) Caterers"
  },
  {
    "id": 722330,
    "title": "Mobile Food Services",
    "display_name": "(722330) Mobile Food Services"
  },
  {
    "id": 722410,
    "title": "Drinking Places (Alcoholic Beverages)",
    "display_name": "(722410) Drinking Places (Alcoholic Beverages)"
  },
  {
    "id": 722511,
    "title": "Full-Service Restaurants",
    "display_name": "(722511) Full-Service Restaurants"
  },
  {
    "id": 722513,
    "title": "Limited-Service Restaurants",
    "display_name": "(722513) Limited-Service Restaurants"
  },
  {
    "id": 722514,
    "title": "Cafeterias, Grill Buffets, and Buffets",
    "display_name": "(722514) Cafeterias, Grill Buffets, and Buffets"
  },
  {
    "id": 722515,
    "title": "Snack and Nonalcoholic Beverage Bars",
    "display_name": "(722515) Snack and Nonalcoholic Beverage Bars"
  },
  {
    "id": 811111,
    "title": "General Automotive Repair",
    "display_name": "(811111) General Automotive Repair"
  },
  {
    "id": 811114,
    "title": "Specialized Automotive Repair",
    "display_name": "(811114) Specialized Automotive Repair"
  },
  {
    "id": 811121,
    "title": "Automotive Body, Paint, and Interior Repair and Maintenance",
    "display_name": "(811121) Automotive Body, Paint, and Interior Repair and Maintenance"
  },
  {
    "id": 811122,
    "title": "Automotive Glass Replacement Shops",
    "display_name": "(811122) Automotive Glass Replacement Shops"
  },
  {
    "id": 811191,
    "title": "Automotive Oil Change and Lubrication Shops",
    "display_name": "(811191) Automotive Oil Change and Lubrication Shops"
  },
  {
    "id": 811192,
    "title": "Car Washes",
    "display_name": "(811192) Car Washes"
  },
  {
    "id": 811198,
    "title": "All Other Automotive Repair and Maintenance",
    "display_name": "(811198) All Other Automotive Repair and Maintenance"
  },
  {
    "id": 811210,
    "title": "Electronic and Precision Equipment Repair and Maintenance",
    "display_name": "(811210) Electronic and Precision Equipment Repair and Maintenance"
  },
  {
    "id": 811310,
    "title": "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
    "display_name": "(811310) Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance"
  },
  {
    "id": 811411,
    "title": "Home and Garden Equipment Repair and Maintenance",
    "display_name": "(811411) Home and Garden Equipment Repair and Maintenance"
  },
  {
    "id": 811412,
    "title": "Appliance Repair and Maintenance",
    "display_name": "(811412) Appliance Repair and Maintenance"
  },
  {
    "id": 811420,
    "title": "Reupholstery and Furniture Repair",
    "display_name": "(811420) Reupholstery and Furniture Repair"
  },
  {
    "id": 811430,
    "title": "Footwear and Leather Goods Repair",
    "display_name": "(811430) Footwear and Leather Goods Repair"
  },
  {
    "id": 811490,
    "title": "Other Personal and Household Goods Repair and Maintenance",
    "display_name": "(811490) Other Personal and Household Goods Repair and Maintenance"
  },
  {
    "id": 812111,
    "title": "Barber Shops",
    "display_name": "(812111) Barber Shops"
  },
  {
    "id": 812112,
    "title": "Beauty Salons",
    "display_name": "(812112) Beauty Salons"
  },
  {
    "id": 812113,
    "title": "Nail Salons",
    "display_name": "(812113) Nail Salons"
  },
  {
    "id": 812191,
    "title": "Diet and Weight Reducing Centers",
    "display_name": "(812191) Diet and Weight Reducing Centers"
  },
  {
    "id": 812199,
    "title": "Other Personal Care Services",
    "display_name": "(812199) Other Personal Care Services"
  },

   {
    "id": 812210,
    "title": "Funeral Homes and Funeral Services",
    "display_name": "(812210) Funeral Homes and Funeral Services"
  },
  {
    "id": 812220,
    "title": "Cemeteries and Crematories",
    "display_name": "(812220) Cemeteries and Crematories"
  },
  {
    "id": 812310,
    "title": "Coin-Operated Laundries and Drycleaners",
    "display_name": "(812310) Coin-Operated Laundries and Drycleaners"
  },
  {
    "id": 812320,
    "title": "Drycleaning and Laundry Services (except Coin-Operated)",
    "display_name": "(812320) Drycleaning and Laundry Services (except Coin-Operated)"
  },
  {
    "id": 812331,
    "title": "Linen Supply",
    "display_name": "(812331) Linen Supply"
  },
  {
    "id": 812332,
    "title": "Industrial Launderers",
    "display_name": "(812332) Industrial Launderers"
  },
  {
    "id": 812910,
    "title": "Pet Care (except Veterinary) Services",
    "display_name": "(812910) Pet Care (except Veterinary) Services"
  },
  {
    "id": 812921,
    "title": "Photofinishing Laboratories (except One-Hour)",
    "display_name": "(812921) Photofinishing Laboratories (except One-Hour)"
  },
  {
    "id": 812922,
    "title": "One-Hour Photofinishing",
    "display_name": "(812922) One-Hour Photofinishing"
  },
  {
    "id": 812930,
    "title": "Parking Lots and Garages",
    "display_name": "(812930) Parking Lots and Garages"
  },
  {
    "id": 812990,
    "title": "All Other Personal Services",
    "display_name": "(812990) All Other Personal Services"
  },
  {
    "id": 813110,
    "title": "Religious Organizations",
    "display_name": "(813110) Religious Organizations"
  },
  {
    "id": 813211,
    "title": "Grantmaking Foundations",
    "display_name": "(813211) Grantmaking Foundations"
  },
  {
    "id": 813212,
    "title": "Voluntary Health Organizations",
    "display_name": "(813212) Voluntary Health Organizations"
  },
  {
    "id": 813219,
    "title": "Other Grantmaking and Giving Services",
    "display_name": "(813219) Other Grantmaking and Giving Services"
  },
  {
    "id": 813311,
    "title": "Human Rights Organizations",
    "display_name": "(813311) Human Rights Organizations"
  },
  {
    "id": 813312,
    "title": "Environment, Conservation and Wildlife Organizations",
    "display_name": "(813312) Environment, Conservation and Wildlife Organizations"
  },
  {
    "id": 813319,
    "title": "Other Social Advocacy Organizations",
    "display_name": "(813319) Other Social Advocacy Organizations"
  },
  {
    "id": 813410,
    "title": "Civic and Social Organizations",
    "display_name": "(813410) Civic and Social Organizations"
  },
  {
    "id": 813910,
    "title": "Business Associations",
    "display_name": "(813910) Business Associations"
  },
  {
    "id": 813920,
    "title": "Professional Organizations",
    "display_name": "(813920) Professional Organizations"
  },
  {
    "id": 813930,
    "title": "Labor Unions and Similar Labor Organizations",
    "display_name": "(813930) Labor Unions and Similar Labor Organizations"
  },
  {
    "id": 813940,
    "title": "Political Organizations",
    "display_name": "(813940) Political Organizations"
  },
  {
    "id": 813990,
    "title": "Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)",
    "display_name": "(813990) Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)"
  },
  {
    "id": 814110,
    "title": "Private Households",
    "display_name": "(814110) Private Households"
  },
  {
    "id": 921110,
    "title": "Executive Offices",
    "display_name": "(921110) Executive Offices"
  },
  {
    "id": 921120,
    "title": "Legislative Bodies",
    "display_name": "(921120) Legislative Bodies"
  },
  {
    "id": 921130,
    "title": "Public Finance Activities",
    "display_name": "(921130) Public Finance Activities"
  },
  {
    "id": 921140,
    "title": "Executive and Legislative Offices, Combined",
    "display_name": "(921140) Executive and Legislative Offices, Combined"
  },
  {
    "id": 921150,
    "title": "American Indian and Alaska Native Tribal Governments",
    "display_name": "(921150) American Indian and Alaska Native Tribal Governments"
  },
  {
    "id": 921190,
    "title": "Other General Government Support",
    "display_name": "(921190) Other General Government Support"
  },
  {
    "id": 922110,
    "title": "Courts",
    "display_name": "(922110) Courts"
  },
  {
    "id": 922120,
    "title": "Police Protection",
    "display_name": "(922120) Police Protection"
  },
  {
    "id": 922130,
    "title": "Legal Counsel and Prosecution",
    "display_name": "(922130) Legal Counsel and Prosecution"
  },
  {
    "id": 922140,
    "title": "Correctional Institutions",
    "display_name": "(922140) Correctional Institutions"
  },
  {
    "id": 922150,
    "title": "Parole Offices and Probation Offices",
    "display_name": "(922150) Parole Offices and Probation Offices"
  },
  {
    "id": 922160,
    "title": "Fire Protection",
    "display_name": "(922160) Fire Protection"
  },
  {
    "id": 922190,
    "title": "Other Justice, Public Order, and Safety Activities",
    "display_name": "(922190) Other Justice, Public Order, and Safety Activities"
  },
  {
    "id": 923110,
    "title": "Administration of Education Programs",
    "display_name": "(923110) Administration of Education Programs"
  },
  {
    "id": 923120,
    "title": "Administration of Public Health Programs",
    "display_name": "(923120) Administration of Public Health Programs"
  },
  {
    "id": 923130,
    "title": "Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)",
    "display_name": "(923130) Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)"
  },
  {
    "id": 923140,
    "title": "Administration of Veterans' Affairs",
    "display_name": "(923140) Administration of Veterans' Affairs"
  },
  {
    "id": 924110,
    "title": "Administration of Air and Water Resource and Solid Waste Management Programs",
    "display_name": "(924110) Administration of Air and Water Resource and Solid Waste Management Programs"
  },
  {
    "id": 924120,
    "title": "Administration of Conservation Programs",
    "display_name": "(924120) Administration of Conservation Programs"
  },
  {
    "id": 925110,
    "title": "Administration of Housing Programs",
    "display_name": "(925110) Administration of Housing Programs"
  },
  {
    "id": 925120,
    "title": "Administration of Urban Planning and Community and Rural Development",
    "display_name": "(925120) Administration of Urban Planning and Community and Rural Development"
  },
  {
    "id": 926110,
    "title": "Administration of General Economic Programs",
    "display_name": "(926110) Administration of General Economic Programs"
  },
  {
    "id": 926120,
    "title": "Regulation and Administration of Transportation Programs",
    "display_name": "(926120) Regulation and Administration of Transportation Programs"
  },
  {
    "id": 926130,
    "title": "Regulation and Administration of Communications, Electric, Gas, and Other Utilities",
    "display_name": "(926130) Regulation and Administration of Communications, Electric, Gas, and Other Utilities"
  },
  {
    "id": 926140,
    "title": "Regulation of Agricultural Marketing and Commodities",
    "display_name": "(926140) Regulation of Agricultural Marketing and Commodities"
  },
  {
    "id": 926150,
    "title": "Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors",
    "display_name": "(926150) Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors"
  },
  {
    "id": 927110,
    "title": "Space Research and Technology",
    "display_name": "(927110) Space Research and Technology"
  },
  {
    "id": 928110,
    "title": "National Security",
    "display_name": "(928110) National Security"
  },
  {
    "id": 928120,
    "title": "International Affairs",
    "display_name": "(928120) International Affairs"
  }
  
];
